import React, {
  useEffect,
  useRef,
  useState,
  useContext,
  Fragment,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import { v4 as uuid } from "uuid";
import Cookies from "universal-cookie";
import { ChatbotContext } from "../../context/ChatbotContext";
import Icon, { XIcon, LanguageIcon, ExpandIcon, CollapseIcon, ZoomInIcon, ZoomOutIcon, StudentIcon, GlobeIcon, SendIcon, SearchIcon, CopyIcon, ClipboardIcon, GraduationCapIcon, ExternalLinkIcon, MoneyIcon, ClockIcon, MapPinIcon, BookOpenIcon, MailIcon, PhoneIcon, CheckCircleIcon, LandmarkIcon, AwardIcon, AlertTriangleIcon } from '../common/icons';
import AssessmentIcon, { assessmentKey } from '../common/AssessmentIcon';
// Alternative Language Icon
import FeedbackModal from "../pages/FeedbackModal";
import { useLanguage } from "../../context/LanguageContext";
import Message, { firstNameOf } from "./Message";
import Card from "./Card";
import chathead from "../../assets/Anna_Chathead.png";
import chatloading from "../../assets/chatbot-loading.gif";
import chatbotAvatar from "../../assets/Anna_Chat_Avatar.png";
import QuickReplies from "./QuickReplies";
import { RIASEC_TOTAL_QUESTIONS, parseRiasecIntent, findQuestionText, looksLikeQuestion } from "./riasecIntent";
import CustomModal from "../Modal";
import AssessmentPicker from "./AssessmentPicker";
import ChatLauncher from "./ChatLauncher";
import RecommendedCoursesMessage from "./RecommendedCoursesMessage";
import RecommendedCoursesQuickReply from "./RecommendedCoursesQuickReply";
import CourseDetailsCards from "../pages/CourseDetailsCards";
import { titleCase } from "../../utils/utilityFunctions";
import api from "../../utils/api";
import { trackCourseClick } from "../../utils/api";
import axios from "axios";
import ChatbotDASS42 from "./ChatbotDASS42";
import ChatbotRyff from "./ChatbotRyff";
import ChatbotSDQ from "./ChatbotSDQ";
import ChatbotRiasec from "./ChatbotRiasec";
import TestLaunch from "./testShell/TestLaunch";
import A11yMenu from "./testShell/A11yMenu";
import { useA11yPrefs } from "./testShell/a11y";
import { SessionRatingModal, LeaveTestDialog } from "./testShell/TestDialogs";
import { rememberTerms, termsRemembered } from "./testShell/termsMemory";
import { captureWindow, morphWindow } from "./testShell/windowMorph";
import { startsLeft } from "./AssessmentPicker";
import { useMyTests, fetchMyTests, testsByType, closedText, testName } from "./useMyTests";
import { answersComplete } from "./testShell/sessionApi";
import { refusalReason, startRefusalText } from "./testShell/refusals";
import { useQuickTourOpen } from "./quickTourState";
import { AnswersCard } from "../common/termsCopy";
import { setTestChatBusy } from "../../utils/sharedComputer";
import { useNavigate } from "react-router-dom";
import "../../styles/chatbot.css";
import {
  Row,
  Col,
  Spinner,
  ListGroup,
  Button,
  Dropdown,
  Form,
  InputGroup,
  Badge,
  Modal,
  Nav,
  Tab,
} from "react-bootstrap";
// Import Language Icon
// Another option
// Another optiodn
// Add this line
import apiNode from "../../components/chatbot/apiNode";
import { postByCourses } from "./riasec/otherSchools";
import { AnimatePresence, motion } from "framer-motion";
import { discardTest, signedInUserId } from "./testShell/answerOutbox";
import { matchCrisis } from "./crisisPhrases";
import { crisisReply, matchIntent, replyFor } from "./mainChatIntents";
import MainChatReply from "./MainChatReply";
import HomeCards from "./HomeCards";
import { OPEN_TEST_EVENT, takeTestRequest } from "./openTestRequest";

const cookies = new Cookies();

// Career interests (RIASEC) on the shared test shell instead of the Dialogflow chat.
// false brings back the old Dialogflow flow, which is still in this file.
const RIASEC_ON_SHELL = true;

const Chatbot = () => {
  // Ensure userId exists before anything else
  if (!cookies.get("userId") || cookies.get("userId").trim() === "") {
    const newUserId = uuid();
    cookies.set("userId", newUserId, { path: "/" });
  }
  


  
  const [refresh, setRefresh] = useState(false);
  const { language, switchLanguage } = useLanguage();
  const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false);
  const [showAssessmentSelectionModal, setShowAssessmentSelectionModal] = useState(false);
  const [availableAssessments, setAvailableAssessments] = useState(['riasec']);
  const [deadlineMessages, setDeadlineMessages] = useState({});
  const [deadlineChecking, setDeadlineChecking] = useState(false);
  // The test picker opens at once and fills in while the checks behind it come back
  const [pickerLoading, setPickerLoading] = useState(false);
  
  // Helper function to get saved state from localStorage - defined first
  const getSavedState = () => {
    try {
      const userId = cookies.get("userId");
      if (!userId) {
        return null;
      }
      
      const savedData = localStorage.getItem(`chatbot_state_${userId}`);
      
      if (savedData) {
        const parsed = JSON.parse(savedData);
        
        // Check if saved data is not too old (e.g., 24 hours)
        const savedTime = parsed.timestamp || 0;
        const currentTime = Date.now();
        const hoursDiff = (currentTime - savedTime) / (1000 * 60 * 60);
        
        if (hoursDiff < 24) {
          return parsed;
        } else {
          // Clear old data
          localStorage.removeItem(`chatbot_state_${userId}`);
        }
      }
    } catch (error) {
      // Error loading saved state
    }
    return null;
  };

  // Do not preload saved state automatically
  const savedState = null;

  // Initialize messages with saved state if available
  const initializeMessages = () => {
    if (savedState && savedState.messages && savedState.messages.length > 0) {

      // Don't include the terms message if we're resuming
      const filteredMessages = savedState.messages.filter(msg => msg.keyword !== "terms-conditions");
      if (filteredMessages.length > 0) {
        return filteredMessages;
      }
    }
    

    return [
      {
        speaks: "bot",
        keyword: "terms-conditions",
        msg: {
          text: {
            text:
              language === "fil"
                ? "Kumusta! 👋 Bago tayo magsimula, sa session na ito ay kukunin ko ang iyong pangunahing impormasyon. <strong>Kailangan mo munang basahin at sumang-ayon sa mga tuntunin</strong> na ipinakita sa"
                : "Hello! 👋 Before we begin, in this session I will take your basic information. <strong>You must first read and agree on the terms presented in the</strong>",
          },
        },
      },
    ];
  };

  const [messages, setMessages] = useState(initializeMessages);
  const [textMessage, setTextMessage] = useState("");
  const {
    isAgreeTermsConditions,
    setIsAgreeTermsConditions,
    showBot,
    setShowbot,
    hideChatbot,
    inputRef,
    disabledInput,
    setDisabledInput,
    setIsVisibleInput,
    isVisibleInput,
    botChatLoading,
    setBotChatLoading,
    basis,
    setBasis,
    setIsRecommendationProvided,
    isRecommendationProvided,
  } = useContext(ChatbotContext);

  const messagesRef = useRef(null);
  const [courseOptionsTimer, setCourseOptionsTimer] = useState("");
  const [user, setUser] = useState({ name: "", age: "", sex: "", strand: "" });
  // Initialize all state variables with saved state if available
  const [riasec, setRiasec] = useState({
      realistic: 0,
      investigative: 0,
      artistic: 0,
      social: 0,
      enterprising: 0,
      conventional: 0,
  });
  const [riasecCode, setRiasecCode] = useState([]);
  const [fallbackCount, setFallbackCount] = useState({});
  const [endConversation, setEndConversation] = useState(false);
  const [isBasicInfoProvided, setIsBasicInfoProvided] = useState(false);
  const [testStarted, setTestStarted] = useState(false);
  const [knownCourses, setKnownCourses] = useState([]);
  const [riasecBasedRecommendedCourses, setRiasecBasedRecommendedCourses] = useState([]);
  const [strandBasedRecommendedCourses, setStrandBasedRecommendedCourses] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isStrandRecommendationTriggered, setIsStrandRecommendationTriggered] = useState(false);
  const [showAllCourses, setShowAllCourses] = useState(false);
  const [expandedCourses, setExpandedCourses] = useState({});
  const DEFAULT_VISIBLE_COURSES = 10; // Default number of visible courses
  const MAX_VISIBLE_COURSES = 30; // Maximum courses that can be shown
  const [visibleCourses, setVisibleCourses] = useState(DEFAULT_VISIBLE_COURSES);
  const [courseSearchTerm, setCourseSearchTerm] = useState("");

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedbackComment, setFeedbackComment] = useState("");
  const [riasecCourses, setRiasecCourses] = useState({});
  const [coursePreview, setCoursePreview] = useState([]);
  const [isLoadingCourses, setIsLoadingCourses] = useState(false);
  // Cache popularity-sorted orders for modal lists
  const [popularOrderCache, setPopularOrderCache] = useState({});

  // Add state for enlarged chatbot
  const [isEnlarged, setIsEnlarged] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  // Track last shown RIASEC question text to persist with responses
  const [lastRiasecQuestionText, setLastRiasecQuestionText] = useState("");

  const [hasStartedConversation, setHasStartedConversation] = useState(savedState?.hasStartedConversation || false);

  // Add state for warning system delay
  const [warningsActive, setWarningsActive] = useState(false);

  // Add state for custom warning modal
  const [showCustomWarning, setShowCustomWarning] = useState(false);

  // Add these state variables near the top with other useState declarations
  const [showCourseDetailsModal, setShowCourseDetailsModal] = useState(false);
  const [selectedCourseDetails, setSelectedCourseDetails] = useState(null);
  const [showViewDetailsButton, setShowViewDetailsButton] = useState(false);
  const [offerings, setOfferings] = useState([]);
  const schoolDisplayName = (offerings && offerings[0] && offerings[0].school_name) || "your school";
  const [otherSchools, setOtherSchools] = useState([]);
  const [otherSchoolsLoading, setOtherSchoolsLoading] = useState(false);
  const [activeSchoolTab, setActiveSchoolTab] = useState(0);
  const [coursesAtOtherSchools, setCoursesAtOtherSchools] = useState(new Set());
  const [modalThemeColor, setModalThemeColor] = useState('#0d6efd');
  const [forceStartOver, setForceStartOver] = useState(false);
  const [showStartOverConfirm, setShowStartOverConfirm] = useState(false);
  
  // Multi-assessment progress indicator state
  const [showProgressIndicator, setShowProgressIndicator] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(42); // Default RIASEC questions
  const [showRecommendationsPhase, setShowRecommendationsPhase] = useState(false);
  const [isTestComplete, setIsTestComplete] = useState(false);
  const [currentAssessmentView, setCurrentAssessmentView] = useState('main'); // 'main', 'dass42', 'ryff', 'sdq'
  const [existingAssessmentSessions, setExistingAssessmentSessions] = useState([]);
  const [showResumeModal, setShowResumeModal] = useState(false);
  // The unfinished test the student asked to start over (resume window), while they confirm
  const [restartTarget, setRestartTarget] = useState(null);
  const [restarting, setRestarting] = useState(false);
  const [restartError, setRestartError] = useState('');
  const [ryffSessionId, setRyffSessionId] = useState(null);
  const [ryffSavedProgress, setRyffSavedProgress] = useState(null);
  const [ryffStartIndex, setRyffStartIndex] = useState(0);
  // Unfinished tests shown as "Continue" in the picker: { dass42: { current, total, session } }
  const [pickerProgress, setPickerProgress] = useState({});
  // Where each test stands, from the server (useMyTests.js): the picker, "Next test" and the
  // resume check read it instead of working deadlines out here. Loaded when the picker opens.
  const myTests = useMyTests({ skip: true });

  // Test shell (DASS-42, SDQ, Ryff): tests finished in this chat session, the rating window
  // that opens when the student leaves, and the "Leave for now?" check mid-test
  const navigate = useNavigate();
  const [finishedTests, setFinishedTests] = useState([]);
  const [ratingRequest, setRatingRequest] = useState(null);
  const [leavePrompt, setLeavePrompt] = useState(null);
  const testActiveRef = useRef({ active: false, question: 0, key: null });

  // Helper function to get assessment display name
  const getAssessmentDisplayName = (assessmentType) => {
    const assessmentNames = {
      'main': 'Career interests',
      'riasec': 'Career interests',
      'dass42': 'Mood and stress',
      'ryff': 'Well-being',
      'sdq': 'Strengths and difficulties'
    };
    return assessmentNames[assessmentType] || 'Assessment';
  };

  const TEST_ORDER = ['riasec', 'dass42', 'ryff', 'sdq'];
  const TEST_TITLES = {
    riasec: 'Career interests',
    dass42: 'Mood and stress check',
    ryff: 'Well-being check',
    sdq: 'Strengths and difficulties',
  };
  const FEEDBACK_CATEGORY = { riasec: 'chatbot', dass42: 'dass42', ryff: 'ryff', sdq: 'sdq' };
  // "How was the mood and stress check?" when the rating window asks about one test
  const TEST_PHRASES = {
    riasec: 'the career interests test',
    dass42: 'the mood and stress check',
    ryff: 'the well-being check',
    sdq: 'the strengths and difficulties check',
  };

  /** The next assigned test the student can still start, skipping ones done in this session. */
  const nextTestAfter = (currentKey) => {
    const serverTests = myTests.tests ? testsByType(myTests.tests) : null;
    const key = TEST_ORDER.find((type) =>
      type !== currentKey &&
      (availableAssessments || []).includes(type) &&
      !finishedTests.some((done) => done.key === type) &&
      (serverTests && serverTests[type]
        ? ['open', 'in_progress'].includes(serverTests[type].status)
        : !(deadlineMessages && deadlineMessages[type]) && startsLeft(user, type) !== 0)
    );
    return key ? { key, title: TEST_TITLES[key] } : null;
  };

  /** Ask for a rating (once per session, never after worrying answers), then carry on. */
  const leaveWithRating = (after) => {
    const tests = finishedTests
      .filter((done) => !done.worrying && !done.asked)
      .map((done) => ({ key: done.key, title: TEST_TITLES[done.key], phrase: TEST_PHRASES[done.key], category: FEEDBACK_CATEGORY[done.key] }));
    if (tests.length === 0) {
      after();
      return;
    }
    setFinishedTests((prev) => prev.map((done) => ({ ...done, asked: true })));
    setRatingRequest({ tests, after });
  };

  const handleTestFinished = ({ key, status, worrying }) => {
    setFinishedTests((prev) => [...prev.filter((done) => done.key !== key), { key, status, worrying, asked: false }]);
  };

  const handleTestAction = (kind, info = {}) => {
    switch (kind) {
      case 'results':
        leaveWithRating(() => navigate(`/results?tab=${info.resultsTab || info.key}`));
        break;
      case 'counselor':
        leaveWithRating(() => navigate(`/book-appointment?reason=${info.reason || 'general'}`));
        break;
      case 'book':
        navigate(`/book-appointment?reason=${info.reason || 'personal'}`);
        break;
      case 'next':
        if (info.nextKey) {
          testActiveRef.current = { active: false, question: 0, key: null };
          // The launch screen goes up first, so the main chat never flashes between the two tests
          setLaunchingTest(info.nextKey);
          setLaunchPending(true);
          setCurrentAssessmentView('main');
          setTimeout(() => handleConfirmAssessment(info.nextKey), 0);
        }
        break;
      case 'done':
      case 'notnow':
      default:
        leaveWithRating(closeChatAfterTest);
        break;
    }
  };

  /**
   * The test picker, always reachable ("Choose a test", "Switch test", "Choose another test"):
   * assigned tests to start, plus any the student started, shown as "Continue · question n of N".
   */
  const openTestPicker = async () => {
    testActiveRef.current = { active: false, question: 0, key: null };
    setShowProgressIndicator(false);
    setCurrentAssessmentView('main');
    setHasAgreedToTerms(true);
    // Open straight away: unfinished tests, assigned tests and deadlines load side by side
    setPickerLoading(true);
    setShowAssessmentSelectionModal(true);
    await Promise.all([loadPickerProgress(), fetchUserAssignedAssessments()]);
    setPickerLoading(false);
  };

  // Tests the student has started, shown as "Continue · question n of N" in the picker
  const loadPickerProgress = async () => {
    const open = {};
    try {
      const [response] = await Promise.all([api.get('/api/get-assessment-progress/'), myTests.reload()]);
      Object.entries(response?.data?.assessment_progress || {}).forEach(([type, p]) => {
        // Every answer saved but never sent (the phone died after the last one): "Finish" (F7)
        const finish = Boolean(p && p.session_id && answersComplete(p, p.total));
        if (p && p.session_id && p.status !== 'completed' && ((p.current > 0 && p.current < p.total) || finish)) {
          open[type] = {
            current: p.current,
            total: p.total,
            finish,
            session: {
              assessment_type: type,
              session_id: p.session_id,
              current_question: p.current,
              total_questions: p.total,
              progress_percentage: p.progress_percentage,
              session_token: p.session_token,
              responses: p.responses,
              session_data: p.session_data || {},
              status: p.status || 'in_progress',
            },
          };
        }
      });
    } catch {
      // No progress to show; the picker still lists the assigned tests
    }
    setPickerProgress(open);
  };

  /** Close the chat after a test ends (or before it starts); next time it opens fresh, not on the old test. */
  const closeChatAfterTest = () => {
    setShowbot(false);
    if (!testActiveRef.current.active) {
      setCurrentAssessmentView('main');
      setShowProgressIndicator(false);
    }
  };
  

  // Simple theme change handler - prevent infinite loops
  const handleThemeColorChange = useCallback((newColor) => {
    if (newColor && newColor !== modalThemeColor) {
      setModalThemeColor(newColor);
    }
  }, [modalThemeColor]);
  

  // The chat used to copy itself (messages, name, age, sex) into localStorage as
  // chatbot_state_<id> but never read it back; resume comes from the server, so that
  // copy is gone (it stayed behind on shared computers).

  // The chat going away ends any test it was showing (utils/sharedComputer.js)
  useEffect(() => () => setTestChatBusy(false), []);

  // Add this useEffect to fetch offerings data
  useEffect(() => {
    const fetchOfferings = async () => {
      try {
        const response = await api.get("/api/public/offerings/");
        setOfferings(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch offerings:", error);
      }
    };
    fetchOfferings();
  }, []);

  // Restore question text and RIASEC scores from localStorage when component mounts
  useEffect(() => {
    restoreQuestionTextFromStorage();
  }, []);


  // Course names carried by chat messages, as a JSON string so the availability check
  // below only re-runs (and re-POSTs) when this list changes, not on every new message.
  const messageCourseNamesKey = useMemo(() => {
    const names = [];
    messages.forEach(message => {
      if (message.courses && Array.isArray(message.courses)) {
        message.courses.forEach(course => {
          const courseName = typeof course === 'string' ? course : (course.name || course.stringValue || '');
          if (courseName) names.push(courseName);
        });
      }
    });
    return JSON.stringify(names);
  }, [messages]);

  // Check which courses are offered at other schools when recommendations change
  const checkAllCoursesAtOtherSchools = useCallback(async (specificCourse = null) => {

    
    const allCourses = new Set();
    
    // If a specific course is provided, always include it
    if (specificCourse) {
      allCourses.add(specificCourse);

    }
    
    // Collect courses from RIASEC recommendations
    riasecBasedRecommendedCourses.forEach(course => {
      const courseName = typeof course === "string" ? course : (course.name || course.stringValue || "");
      if (courseName) {
        allCourses.add(courseName);
        if (courseName.toLowerCase().includes('geology') || courseName.toLowerCase().includes('nutrition')) {
          }
      }
    });
    
    // Collect courses from Strand recommendations
    strandBasedRecommendedCourses.forEach(course => {
      const courseName = typeof course === "string" ? course : (course.name || course.stringValue || "");
      if (courseName) {
        allCourses.add(courseName);
        if (courseName.toLowerCase().includes('geology') || courseName.toLowerCase().includes('nutrition')) {
          }
      }
    });
    
    // IMPORTANT: Also collect courses from popular/fallback lists that might be shown
    // Check if we have any cached popularity data that might contain additional courses
    Object.values(popularOrderCache).forEach(cacheEntry => {
      if (cacheEntry && cacheEntry.order && Array.isArray(cacheEntry.order)) {
        cacheEntry.order.forEach(courseName => {
          if (courseName && typeof courseName === 'string') {
            allCourses.add(courseName);
            if (courseName.toLowerCase().includes('geology') || courseName.toLowerCase().includes('nutrition')) {
              }
          }
        });
      }
    });
    
    // (Six hard-coded courses used to be added here for a pop-up that no longer exists. N13)

    // Old logic for collecting from messages (keeping as fallback)
    JSON.parse(messageCourseNamesKey).forEach(courseName => allCourses.add(courseName));
    
    // Optimized: Check all courses in a single API call
    if (allCourses.size > 0) {
      try {
        // Use the by-courses endpoint to get data for ALL schools offering these courses
        const courseNamesArray = Array.from(allCourses);
        
        const byCoursesResponse = await postByCourses({ names: courseNamesArray }); // parts of 60 (F16)
        
        if (byCoursesResponse.data && byCoursesResponse.data.results) {
          const coursesWithOtherSchools = new Set();
          const currentSchoolName = schoolDisplayName.toLowerCase();
          
          // Check each recommended course
          for (const courseName of allCourses) {
            // Find the course in the results
            const courseKey = courseName.toLowerCase();
            const courseEntry = byCoursesResponse.data.results[courseKey];
            
            if (courseEntry && courseEntry.schools) {
              // Filter out current school and check if any other schools offer it
              const otherSchoolsOffering = courseEntry.schools.filter(
                school => (school.name || "").toLowerCase() !== currentSchoolName
              );
              
              if (otherSchoolsOffering.length > 0) {
                const keyToAdd = courseName.toLowerCase();
                coursesWithOtherSchools.add(keyToAdd);
                if (courseName.toLowerCase().includes('geology') || courseName.toLowerCase().includes('nutrition')) {
                }
              }
            }
          }
          
          setCoursesAtOtherSchools(coursesWithOtherSchools);
          
          // Return the updated data for immediate use
          return coursesWithOtherSchools;
        }
      } catch (error) {
        console.error("Error checking courses at other schools:", error);
        setCoursesAtOtherSchools(new Set());
        return new Set();
      }
    }
    
    return new Set();
  }, [riasecBasedRecommendedCourses, strandBasedRecommendedCourses, schoolDisplayName, popularOrderCache, messageCourseNamesKey]);

  // (It also ran on every chat open and every new message, posting to by-courses with nothing
  // to show it for. It now runs only when a course list or course details actually open. N13)

  // Auto-scroll when messages change or View Details button appears
  useEffect(() => {
    if (messages.length > 0 || showViewDetailsButton) {
      // Small delay to ensure DOM is updated
      setTimeout(() => {
        handleMessagesScrollToBottom();
      }, 100);
    }
  }, [messages, showViewDetailsButton]);

  // Helper function for three-tier priority sorting (same as Results.js)
  const sortCoursesByPriority = (courses, popularityOrder, isForStrand = false) => {
    return courses.sort((a, b) => {
      const courseName = isForStrand ? a : (a.name || a);
      const otherCourseName = isForStrand ? b : (b.name || b);
      
      // Check if course is offered by current tenant
      const aIsOfferedByCurrentTenant = offerings.some(
        (o) => o.course_name.toLowerCase() === courseName.toLowerCase() && o.is_offered !== false
      );
      const bIsOfferedByCurrentTenant = offerings.some(
        (o) => o.course_name.toLowerCase() === otherCourseName.toLowerCase() && o.is_offered !== false
      );
      
      // Check if course is offered by other schools
      const aIsOfferedByOthers = coursesAtOtherSchools.has(courseName.toLowerCase());
      const bIsOfferedByOthers = coursesAtOtherSchools.has(otherCourseName.toLowerCase());
      
      // Calculate priority levels (lower number = higher priority)
      const getPriority = (isCurrentTenant, isOthers) => {
        if (isCurrentTenant) return 1; // Highest priority - Current tenant courses
        if (isOthers) return 2; // Medium priority - Other schools courses
        return 3; // Lowest priority - Popular courses only
      };
      
      const aPriority = getPriority(aIsOfferedByCurrentTenant, aIsOfferedByOthers);
      const bPriority = getPriority(bIsOfferedByCurrentTenant, bIsOfferedByOthers);
      
      // Sort by priority first
      if (aPriority !== bPriority) {
        return aPriority - bPriority;
      }
      
      // Within same priority level, sort by popularity
      const aIndex = popularityOrder.indexOf(isForStrand ? a : (a.name || a));
      const bIndex = popularityOrder.indexOf(isForStrand ? b : (b.name || b));
      
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      
      return aIndex - bIndex;
    });
  };

  const fetchOtherSchools = async (courseName) => {
    try {
      setOtherSchoolsLoading(true);
      
      // Debug API configuration
      console.log('🎯 API configuration debug:', {
        apiDefaults: api.defaults,
        baseURL: api.defaults.baseURL,
        courseName
      });
      
      // Request detailed course offering data from the updated API
      const resp = await api.post("/api/public/offerings/by-courses/", {
        names: [courseName],
        include_details: true  // Request full course offering details
      });
      const results = resp?.data?.results || {};
      const key = (courseName || "").trim().toLowerCase();
      const entry = results[key] || Object.values(results).find(
          (e) => e?.course_name?.toLowerCase() === key,
        ) || { schools: [] };
      
      if (entry.schools && Array.isArray(entry.schools)) {
        // Filter out current school
        const currentSchoolName = schoolDisplayName.toLowerCase();
        const otherSchoolsWithDetails = entry.schools.filter(
          school => (school.name || school.school_name || "").toLowerCase() !== currentSchoolName
        );
        
        
        // The schools array now contains full course offering details
        const completeOtherSchools = otherSchoolsWithDetails.map(schoolData => {
          const schoolIdForLogo = schoolData.school_id || schoolData.id;
          const logoUrl = schoolIdForLogo ? `${api.defaults.baseURL}/api/school-logo/${schoolIdForLogo}/` : null;
          
          // Debug logo URL construction
          console.log('🎯 Logo URL construction debug:', {
            school: schoolData.name || schoolData.school_name,
            schoolId: schoolIdForLogo,
            apiBaseURL: api.defaults.baseURL,
            constructedLogoUrl: logoUrl
          });
          
          return {
            id: schoolData.id,
            school_id: schoolData.school_id || null,
            name: schoolData.name || schoolData.school_name,
            school_name: schoolData.name || schoolData.school_name,
            school_address: schoolData.school_address || "Contact school",
            // Provide proxy logo URL so CourseDetailsCards can render logo and extract colors
            school_logo: logoUrl,
            course_name: courseName,
            
            // Use the actual course offering fields from API response
            tuition_min: schoolData.tuition_min,
            tuition_max: schoolData.tuition_max,
            currency: schoolData.currency || "PHP",
            degree_level: schoolData.degree_level,
            modality: schoolData.modality,
            duration_years: schoolData.duration_years,
            campus_location: schoolData.campus_location || schoolData.school_address,
            application_link: schoolData.application_link,
            contact_email: schoolData.contact_email,
            contact_phone: schoolData.contact_phone,
            admission_requirements: schoolData.admission_requirements,
            scholarship_available: schoolData.scholarship_available,
            slots_available: schoolData.slots_available,
            notes: schoolData.notes,
            is_offered: schoolData.is_offered !== false
          };
        });
        
        setOtherSchools(completeOtherSchools);
      } else {
        setOtherSchools([]);
      }
    } catch (e) {
      console.error("Error in fetchOtherSchools:", e);
      setOtherSchools([]);
    } finally {
      setOtherSchoolsLoading(false);
    }
  };

  

  // Warning functions
  const triggerCustomWarning = () => {
    setShowCustomWarning(true);
  };

  const handleWarningContinue = () => {
    setShowCustomWarning(false);
  };

  const handleWarningClose = () => {
    setShowCustomWarning(false);
    setShowbot(false);
  };

  // Add warning for leaving before finishing conversation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (
        isAgreeTermsConditions &&
        hasStartedConversation &&
        warningsActive &&
        !endConversation
      ) {
        const message =
          "You haven't finished your career interests test. Your answers so far are saved, and you can pick up where you left off.";
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    const handleVisibilityChange = () => {
      if (
        document.hidden &&
        isAgreeTermsConditions &&
        hasStartedConversation &&
        warningsActive &&
        !endConversation
      ) {
        // User switched tabs or minimized browser
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [
    isAgreeTermsConditions,
    hasStartedConversation,
    endConversation,
    showBot,
    warningsActive,
  ]);

  // Toggle enlarge function: the window flies between its two sizes (testShell/windowMorph.js)
  const morphFrom = useRef(null);
  const toggleEnlarge = () => {
    morphFrom.current = captureWindow(document.querySelector(".chatbot"));
    setIsEnlarged(!isEnlarged);
    if (isEnlarged) {
      setShowTooltip(true); // Show tooltip when minimizing
      setTimeout(() => setShowTooltip(false), 5000); // Hide after 5 seconds
    }
  };
  useLayoutEffect(() => {
    const from = morphFrom.current;
    morphFrom.current = null;
    if (from) morphWindow(document.querySelector(".chatbot"), from);
  }, [isEnlarged]);

  // Auto-hide tooltip after 5 seconds on mount
  useEffect(() => {
    if (isEnlarged && showTooltip) {
      const timer = setTimeout(() => {
        setShowTooltip(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isEnlarged, showTooltip]);

  const fetchUserInfo = async () => {
    try {
      const accessToken = localStorage.getItem("authToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken) {
        setIsLoggedIn(false);
        setUser(null);
        return;
      }

      const checkLoginStatus = async (token) => {
        return api.get("/api/check_login_status/", {
          headers: { Authorization: `Bearer ${token}` },
        });
      };

      let response = await checkLoginStatus(accessToken);

      if (response.status === 401 && refreshToken) {
        const refreshResponse = await api.post("/api/token/refresh/", {
          refresh: refreshToken,
        });
        if (refreshResponse.status === 200) {
          localStorage.setItem("authToken", refreshResponse.data.access);
          response = await checkLoginStatus(refreshResponse.data.access);
        } else {
          setIsLoggedIn(false);
          setUser(null);
          return;
        }
      }

      const data = response.data;
      if (response.status === 200 && data.is_logged_in && data.user_data) {
        setUser({
          name: data.user_data.name,
          age: data.user_data.age,
          sex: data.user_data.sex,
          strand: data.user_data.strand,
          school_name: data.user_data.school_name || null,
          current_section: data.user_data.current_section || null, // Grade / college for riasecLogic.stageOf (N5)
          max_chatbot_starts: data.user_data.max_chatbot_starts,
          extended_deadline: data.user_data.extended_deadline, // Optional individual override
        });
        try {
          localStorage.setItem(
            'max_chatbot_starts',
            JSON.stringify(data.user_data.max_chatbot_starts)
          );
        } catch {}
        setIsLoggedIn(true);
        setIsBasicInfoProvided(true);

        // Proactively fetch max_chatbot_starts from backend when not present in login payload
        try {
          if (data.user_data.max_chatbot_starts === undefined || data.user_data.max_chatbot_starts === null) {
            const mcsResp = await api.get('/api/check-max-chatbot-starts/', {
              headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
            });
            const mcs = mcsResp?.data?.max_chatbot_starts;
            if (mcs) {
              setUser(prev => ({ ...prev, max_chatbot_starts: mcs }));
              try {
                localStorage.setItem('max_chatbot_starts', JSON.stringify(mcs));
                console.log('[fetchUserInfo] Loaded max_chatbot_starts from API');
              } catch {}
            }
          }
        } catch (e) {
          console.warn('Could not load max_chatbot_starts from API:', e?.message || e);
        }
        // (An old block here started the Dialogflow RIASEC chat by itself, or closed the chat
        // when no starts were left, whenever this re-ran after the terms were agreed. N13)
      } else {
        setIsLoggedIn(false);
        setUser(null);
        setIsBasicInfoProvided(false);
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
      setIsLoggedIn(false);
      setUser(null);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    // Listen for chatbot refresh event after login
    const handleChatbotRefresh = () => {
      // Re-fetch the user info and refresh the chatbot state
      fetchUserInfo(); // This will trigger the chatbot to refresh with the user's data
    };

    window.addEventListener("chatbotRefresh", handleChatbotRefresh);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("chatbotRefresh", handleChatbotRefresh);
    };
  }, []);
  const fetchRiasecCourses = async (riasecCode) => {
    if (!riasecCode || riasecCode.length === 0) return;

    setIsLoadingCourses(true);
    let coursesByCategory = {};
    let preview = [];

    try {
      for (let i = 0; i < riasecCode.length; i++) {
        const [category] = riasecCode[i];
        const response = await apiNode.get(`/api/courses?riasec=${category}`);
        const courses = response.data || [];

        coursesByCategory[category] = courses;

        if (i === 0) {
          preview.push(...courses.slice(0, 4)); // First category gets 4 courses
        } else {
          preview.push(...courses.slice(0, 3)); // Others get 3 each
        }
      }

      setRiasecCourses(coursesByCategory);
      setCoursePreview(preview);
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setIsLoadingCourses(false);
    }
  };

  useEffect(() => {
    // Re-fetch the necessary chatbot state or trigger RIASEC_START
    // You can fetch the user info here or refresh the chatbot state
  }, [refresh]);
  useEffect(() => {
    const handleLoginSuccess = (e) => {
      const userData = e.detail;
      if (!userData) return;

      setUser({
        name: userData.name,
        age: userData.age,
        sex: userData.sex,
        strand: userData.strand,
        school_name: userData.school_name || null,
        current_section: userData.current_section || null,
      });

      // Set flags when user data is loaded
      setTestStarted(true);
      setHasStartedConversation(true);
    };

    window.addEventListener("loginSuccess", handleLoginSuccess);

    return () => {
      window.removeEventListener("loginSuccess", handleLoginSuccess);
    };
  }, []);
  // (df_text_query, which sent typed text to Dialogflow and locked the chat after five misses,
  // is gone: the main chat reads typed text itself, see send() below. F13)

    const df_event_query = async (event, parameters = {}) => {
        try {
            setBotChatLoading(true);  
    
            let sessionId = cookies.get('userId');
            if (!sessionId || sessionId.trim() === '') {
                sessionId = uuid();
                cookies.set('userId', sessionId, { path: '/' });
                console.log('Generated new session ID:', sessionId);
            }
            
            const currentLanguage = language || 'en';
            // Use parameters as-is, no localStorage enrichment
            const body = { event, userId: sessionId, parameters, lang: currentLanguage };

            const response = await apiNode.post('/api/df_event_query', body);
            const data = response.data;
            setBotChatLoading(false);
    
            if (response.status !== 200) {
                throw new Error(`Failed to fetch Dialogflow event. Status: ${response.status}`);
            }
    
    
            // Extract name from parameters (even if set via event)
            // ✅ Fix: Extract Name Correctly (Handles Nested Structure)
            const extractedName = data.parameters?.fields?.name?.listValue?.values?.[0]?.structValue?.fields?.name?.stringValue;
            if (extractedName) {
                console.log("✅ Extracted Name from Event Query:", extractedName);
                setUser((prev) => ({ ...prev, name: extractedName }));
            }
        
            // Append fulfillment messages to `messages` state
            if (data.fulfillmentMessages) {
                data.fulfillmentMessages.forEach((msg) => {
                    let processedMsg = { ...msg };
                    
                    // Special handling for RIASEC_RESUME event - replace generic message with stored question
                    if (event === 'RIASEC_RESUME' && msg.text?.text?.[0] && parameters?.next_question_text) {
                        const currentText = msg.text.text[0].toLowerCase();
                        // Check if this is the generic "ready for the next question" message
                        if (currentText.includes('ready for the next question') || currentText.includes('ready for question')) {
                            console.log('🔄 Replacing generic resume message with stored question:', parameters.next_question_text);
                            processedMsg = {
                                ...msg,
                                text: {
                                    text: [parameters.next_question_text]
                                }
                            };
                        }
                    }
                    
                    const botSays = {
                        speaks: 'bot',
                        msg: processedMsg,
                    };
                    setMessages((prev) => [...prev, botSays]); // Append to messages state
                });
            } else {
                console.warn('No fulfillment messages found in response.');
            }

            // Remember the RIASEC question shown by these events so its wording is saved with the answer
            if (event === 'RIASEC_START') {
                setCurrentQuestionText(findQuestionText(data.fulfillmentMessages || []));
            } else if (event === 'RIASEC_RESUME') {
                const resumedQuestion = parameters?.next_question_text || '';
                setCurrentQuestionText(looksLikeQuestion(resumedQuestion) ? resumedQuestion.trim() : '');
            }

            // Handle Default Welcome Intent
            if (data.intent?.displayName === 'Default Welcome Intent') {
                console.log('Triggered Default Welcome Intent.');
                return; // Do not clear state
            }
    
            // Handle fallback intents or unknown intents
            if (!data.intent) {
                console.warn('No intent matched. Triggering fallback...');
                await df_event_query('FALLBACK_EXCEED_TRIGGER_LIMIT');
                clearState();
                setEndConversation(true);
                setDisabledInput(false);
                setIsVisibleInput(true);
                return;
            }
    
            // Process fulfillment messages with additional payload fields
            data.fulfillmentMessages.forEach((msg) => {
                const fields = msg.payload?.fields;
    
                if (!fields) {
                    return; // Plain text messages are handled in the first loop above
                }
    
                // Handle strand recommendation trigger
                if (fields.iswant_strand_recommendation?.boolValue && !isStrandRecommendationTriggered) {
                    console.log('Triggering strand recommendation...');
                    
                    // Check if user has a valid strand
                    if (!user.strand || user.strand.trim() === '' || user.strand.toLowerCase() === 'n/a') {
                        console.log('⚠️ User has no strand assigned, skipping strand recommendation');
                        
                        // Show message and trigger end conversation
                        setMessages((prev) => [
                            ...prev,
                            {
                                speaks: 'bot',
                                msg: {
                                    text: { 
                                        text: "I notice you don't have a strand assigned. Your RIASEC results have been saved. Please consult with a guidance counselor for personalized course recommendations." 
                                    }
                                }
                            }
                        ]);
                        
                        // Trigger conversation end with empty strand courses
                        setStrandBasedRecommendedCourses([]);
                        savedConversation(user, riasecCode, riasecCourses, [], riasec);
                        setIsTestComplete(true);
                        setShowRecommendationsPhase(false);
                        setShowProgressIndicator(false);
                        clearState();
                        setDisabledInput(true);
                        setIsVisibleInput(false);
                    } else {
                        df_event_query('STRAND_RECOMMENDATION', { strand: user.strand });
                    }
                    
                    setIsStrandRecommendationTriggered(true);
                    setIsRecommendationProvided((prev) => ({ ...prev, strand: 'done' }));
                }
    
                // Handle RIASEC logic
                if (fields.riasec?.stringValue) {
                    const riasecValue = fields.riasec.stringValue;
                    console.log('Received RIASEC value:', riasecValue);
    
                    setRiasec((prev) => {
                        const updatedRiasec = { ...prev };
                        switch (riasecValue) {
                            case 'realistic':
                                updatedRiasec.realistic += 1;
                                break;
                            case 'investigative':
                                updatedRiasec.investigative += 1;
                                break;
                            case 'artistic':
                                updatedRiasec.artistic += 1;
                                break;
                            case 'social':
                                updatedRiasec.social += 1;
                                break;
                            case 'enterprising':
                                updatedRiasec.enterprising += 1;
                                if (fields.riasec_last_question?.boolValue) {
                                    handleRiasecRecommendation(updatedRiasec);
                                }
                                break;
                            case 'conventional':
                                updatedRiasec.conventional += 1;
                                break;
                            default:
                                console.warn('Unknown RIASEC value:', riasecValue);
                                break;
                        }
                        return updatedRiasec;
                    });
                }
    
                // Handle recommendations
                if (fields.riasec_recommended_courses?.listValue?.values) {
                    const courses = fields.riasec_recommended_courses.listValue.values.map(
                        (course) => course.stringValue
                    );
                    console.log('RIASEC Recommended Courses:', courses);
                    setRiasecBasedRecommendedCourses(courses);
                }
    
                if (fields.strand_recommended_courses?.listValue?.values) {
                    const courses = fields.strand_recommended_courses.listValue.values.map(
                        (course) => course.stringValue
                    );
                    console.log('Strand Recommended Courses:', courses);
                    setStrandBasedRecommendedCourses(courses);
                }
    
                // Handle end of conversation
                if (fields.end_conversation?.boolValue) {
                    console.log('Ending conversation...');
                    
                    // Check if this is a no_courses_found scenario
                    const noCoursesFound = fields.no_courses_found?.boolValue;
                    if (noCoursesFound) {
                        console.log('⚠️ No courses found for strand, but still saving conversation and results');
                        // Ensure we use empty array for strand courses if not found
                        setStrandBasedRecommendedCourses([]);
                    }
                    
                    // Save conversation regardless of whether courses were found
                    savedConversation(user, riasecCode, riasecCourses, strandBasedRecommendedCourses, riasec);
                    
                    // Show "Test Complete" after saving conversation
                    setIsTestComplete(true);
                    setShowRecommendationsPhase(false);
                    setShowProgressIndicator(false);
                    
                    clearState();
                    setDisabledInput(true);
                    setIsVisibleInput(false);
                }
            });
        } catch (err) {
            console.error('Error sending event to Dialogflow:', err.message);
    
            setBotChatLoading(false);
    
            // Add a generic error message to the `messages` state
            const botSays = {
                speaks: 'bot',
                msg: {
                    text: {
                        text: 'Sorry, something went wrong 🤕. Please try again later.',
                    },
                },
            };
            setMessages((prev) => [...prev, botSays]);
        }
    };

  const triggerCourseOptionYes = () => {
    // this will keep the context exceeds the time limit of 20mins, because users might take time watching the videos
    // after the  course options was rendered, trigger the course option timer after 15 minutes to reset the timer of the intent's context
    // will be cleared after clicking "continue" quick reply
    // only trigger the timer when courseOptionsTimer is empty or no courseOptiontimer tiggered to avoid duplication of timer when component is rendered again
    // timer will still tigger even card component is unmounted
    if (!courseOptionsTimer) {
      const timerId = setInterval(async () => {
        try {
          const body = {
            event: "COURSE_OPTIONS_YES",
            userId: cookies.get("userId"),
          };
          await apiNode.post(
            "/api/df_event_query",
            body,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
        } catch (err) {
          console.error(err.message);
        }
      }, 900000);
      setCourseOptionsTimer(timerId);
    }
  };

  const clearCourseOptionsYes = () => {
    // clear the timer
    clearInterval(courseOptionsTimer);
    setCourseOptionsTimer("");
  };

  const clearState = () => {
    setUser({ name: "", age: "", sex: "", strand: "" });
    setRiasec({
      realistic: 0,
      investigative: 0,
      artistic: 0,
      social: 0,
      enterprising: 0,
      conventional: 0,
    });
    setRiasecCode([]);
    setKnownCourses([]);
    setRiasecBasedRecommendedCourses([]);
    setStrandBasedRecommendedCourses([]);
    setFallbackCount({});
    setEndConversation(false);
    setBasis("");
    setIsRecommendationProvided({ riasec: "", strand: "" });
    
    // Clear saved state from localStorage
    try {
      const userId = cookies.get("userId");
      if (userId) {
        localStorage.removeItem(`chatbot_state_${userId}`);
      }
    } catch (error) {
      console.error("Error clearing saved state:", error);
    }
  };

  // State to store the current question text from Dialogflow
  const [currentQuestionText, setCurrentQuestionText] = useState('');
  
  // Function to get current question text from state
  const getCurrentQuestionText = () => {
    if (currentQuestionText) {
      return currentQuestionText;
    }
    
    // Fallback to generic text based on current step
    return `RIASEC Question ${currentStep}`;
  };
  
  // Function to restore question text from backend (if needed)
  const restoreQuestionTextFromStorage = () => {
    // Question text restoration will be handled by backend session management
    console.log('📊 Question text and session data is now stored in database only');
  };

  // Function to update assessment session progress during RIASEC test
  const updateRiasecAssessmentProgress = async (currentQuestion, responses, riasecScores, nextQuestionText = null, awaitingRecommendations = false, answeredQuestionText = null, rawReplies = null) => {
    try {
      // Get the current session from backend instead of localStorage
      const accessToken = localStorage.getItem("authToken");
      if (!accessToken) {
        console.error('❌ No auth token found');
        return;
      }

      // First get the current assessment progress to find the active session
      const progressResponse = await api.get('/api/get-assessment-progress/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      
      if (progressResponse.status === 200 && progressResponse.data.assessment_progress) {
        const riasecProgress = progressResponse.data.assessment_progress.riasec;
        
        if (riasecProgress && riasecProgress.session_id) {
          const sessionId = riasecProgress.session_id;
          
          // Calculate progress percentage
          const progressPercentage = Math.round((currentQuestion / 42) * 100);
          
          console.log(`🔄 Updating RIASEC progress: ${currentQuestion}/42 (${progressPercentage}%)`);
          console.log('Session ID:', sessionId);
          console.log('RIASEC Scores:', riasecScores);
          console.log('Awaiting Recommendations:', awaitingRecommendations);
          
          // Update the assessment session
          const updateData = {
            session_id: sessionId,
            current_step: currentQuestion,
            scores: riasecScores
          };
          
          // Store awaiting_recommendations flag in session_data (using existing JSON field)
          if (awaitingRecommendations) {
            updateData.session_data = {
              awaiting_recommendations: true,
              riasec_scores: riasecScores
            };
            console.log('🎯 Marking session as awaiting recommendations (can be resumed)');
          }
          
          // Include next question text if provided
          if (nextQuestionText && nextQuestionText.trim()) {
            updateData.next_question_text = nextQuestionText.trim();
          }
          if (answeredQuestionText && answeredQuestionText.trim()) {
            updateData.question_text = answeredQuestionText.trim();
            updateData.question_number = currentQuestion;
          }
          // What the student actually typed or tapped, keyed by question number
          if (rawReplies && Object.keys(rawReplies).length > 0) {
            updateData.raw_replies = rawReplies;
          }
          
          // Only include responses if they contain actual question-answer pairs
          // Don't send empty objects or null values to avoid overwriting existing responses
          if (responses && typeof responses === 'object' && Object.keys(responses).length > 0) {
            // Check if responses contain actual data (not just empty object)
            const hasRealData = Object.values(responses).some(value => value !== null && value !== undefined && value !== '');
            if (hasRealData) {
              updateData.responses = responses;
              console.log('📝 Including responses in update:', responses);
            } else {
              console.log('📝 Skipping empty responses to preserve existing data');
            }
          } else {
            console.log('📝 No responses provided, preserving existing responses in database');
          }
          
          const response = await api.post('/api/update-assessment-progress/', updateData);
          
          console.log('Progress update response:', response.data);
          console.log(`✅ RIASEC progress updated: ${currentQuestion}/42 (${progressPercentage}%)`);
          
          // Check if this should trigger completion
          if (currentQuestion >= 42 && !awaitingRecommendations) {
            console.log('🎯 Assessment should be marked as completed!');
          } else if (currentQuestion >= 42 && awaitingRecommendations) {
            console.log('⏳ Questions complete, awaiting recommendations - can be resumed');
          }
        } else {
          console.error('❌ No active RIASEC session found in backend');
        }
      } else {
        console.error('❌ Failed to get assessment progress from backend');
      }
    } catch (error) {
      console.error('❌ Error updating RIASEC assessment progress:', error);
    }
  };

  const handleRiasecRecommendation = async (riasecScores) => {
    // Define RIASEC order for tie-breaking (R-I-A-S-E-C)
    const riasecOrder = [
      "realistic",
      "investigative",
      "artistic",
      "social",
      "enterprising",
      "conventional",
    ];

    // Custom sort that handles ties by RIASEC order
    const sortRiasec = Object.entries(riasecScores).sort(
      ([nameA, scoreA], [nameB, scoreB]) => {
        // First sort by score (highest first)
        if (scoreB !== scoreA) {
          return scoreB - scoreA;
        }
        // If scores are tied, sort by RIASEC order
        const indexA = riasecOrder.indexOf(nameA);
        const indexB = riasecOrder.indexOf(nameB);
        return indexA - indexB;
      },
    );


    // Always take the top 3 from properly sorted list
    let RIASEC_CODE = sortRiasec.slice(0, 3);


    setRiasecCode(RIASEC_CODE);
    df_event_query("RIASEC_RECOMMENDATION", RIASEC_CODE);
    setIsRecommendationProvided((prev) => ({ ...prev, riasec: "done" }));
    // fetchCoursesByStrand();
    await fetchRiasecCourses(RIASEC_CODE);
  };

  const handleRecommendedCourseClick = async (course) => {
    const courseName =
      typeof course === "string" ? course : course.name || course.stringValue || "";


    // Reset the view details button state at the start of each click
    setShowViewDetailsButton(false);
    setSelectedCourseDetails(null);

    // Store course details for potential modal viewing later
    const offering = offerings.find(
      (o) =>
        o.is_offered && o.course_name.toLowerCase() === courseName.toLowerCase(),
    );
    
    // Always fetch other schools to check availability and wait for completion
    try {
      await fetchOtherSchools(courseName);
    } catch (error) {
      console.error("Error fetching other schools:", error);
    }

    // Refresh coursesAtOtherSchools data with the specific course and wait for completion
    const updatedCoursesAtOtherSchools = await checkAllCoursesAtOtherSchools(courseName);
    
    // Force a small delay to ensure state is fully updated
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Always set the course details for the "View Details" button
    // This ensures the availability message shows up regardless of whether it's offered by current school
    if (offering) {
      // Ensure logo proxy URL for current school as well (use school_id, not offering id)
      setSelectedCourseDetails({
        ...offering,
        school_logo: offering.school_id ? `${api.defaults.baseURL}/api/school-logo/${offering.school_id}/` : offering.school_logo || null,
      });
    } else {
      // Course not offered by current tenant
      setSelectedCourseDetails({ 
        course_name: courseName, 
        is_offered: false,
        school_logo: null // Ensure no logo for courses not offered by current tenant
      });
      // Set course name color for header since no logo will be available
      setModalThemeColor('#ffc107'); // Bootstrap warning color (same as text-warning)
    }
    
    // Use a callback to ensure we have the most up-to-date state
    setCoursesAtOtherSchools(prevState => {
      const currentState = updatedCoursesAtOtherSchools || prevState;
      
      // Always show the view details button if there's availability info to display
      // (either offered by current school OR offered by other schools)
      const hasAvailabilityInfo = offering || (otherSchools && otherSchools.length > 0) || currentState.has(courseName.toLowerCase());
      
      
      if (hasAvailabilityInfo) {
        // Set flag to show the "View Details" button after a delay to simulate Anna's response
        setTimeout(() => {
          setShowViewDetailsButton(true);
          // Auto-scroll to bottom after button appears
          setTimeout(() => {
            handleMessagesScrollToBottom();
          }, 100); // Small delay to ensure button is rendered
        }, 500); // Reduced delay to 0.5 seconds for faster response
      } else {
      }
      
      return currentState;
    });

    // Always go to chat explanation first (Option A)
    const modalEl = document.getElementById("modal-recommended-courses-info");
    
    // Function to proceed with chatbot interaction
    const proceedWithChatbot = async () => {
      
      try {
        // Get RIASEC type from Node API for accurate tracking (like Results page does)
        let riasecType = null;
        if (basis === "riasec") {
          try {
            const formattedCourseName = encodeURIComponent(courseName.trim());
            const nodeResponse = await apiNode.get(`/api/courses?name=${formattedCourseName}`);
            
            if (nodeResponse.data && nodeResponse.data.riasec_area && nodeResponse.data.riasec_area.length > 0) {
              // Use the first RIASEC area from the course database
              riasecType = nodeResponse.data.riasec_area[0];
              console.log(`📊 Found RIASEC type for ${courseName}: ${riasecType}`);
            }
          } catch (error) {
            console.log(`Could not fetch RIASEC type for ${courseName}:`, error);
            // Fallback: use user's primary RIASEC category if available
            if (riasecCode && riasecCode.length > 0) {
              const riasecCategories = riasecCode.map(([category]) => category.toLowerCase());
              riasecType = riasecCategories[0]; // Use the primary (highest scoring) RIASEC category
            }
          }
        }
        
        trackCourseClick(courseName, basis, null, riasecType);
      } catch {}

      const allMessages = messages;
      const userSays = { speaks: "user", msg: { text: { text: courseName } } };
      if (allMessages[allMessages.length - 1]?.msg?.payload?.fields?.quick_replies) {
        allMessages.pop();
      }
      setMessages([...allMessages, userSays]);
      if (!knownCourses.includes(courseName)) setKnownCourses((prev) => [...prev, courseName]);
      
      // Prepare additional parameters with availability information
      const courseAvailabilityInfo = {
        course_to_lookup: courseName,
        is_offered_by_current_school: offering ? true : false,
        has_other_schools: coursesAtOtherSchools.has(courseName.toLowerCase()),
        other_schools_count: otherSchools ? otherSchools.length : 0,
        current_school_name: schoolDisplayName
      };
      
      
      if (basis === "riasec") {
        df_event_query("GET_RIASEC_RECOMMENDATION_COURSE_INFO", courseAvailabilityInfo);
      } else if (basis === "strand") {
        df_event_query("GET_STRAND_RECOMMENDATION_COURSE_INFO", courseAvailabilityInfo);
      }
    };
    
    if (modalEl) {
      // Listen for the modal to be fully hidden before proceeding
      const handleModalHidden = () => {
        modalEl.removeEventListener('hidden.bs.modal', handleModalHidden);
        // Small delay to ensure DOM is settled and data is ready
        setTimeout(() => proceedWithChatbot(), 300);
      };
      
      modalEl.addEventListener('hidden.bs.modal', handleModalHidden);
      
      // Close the modal using Bootstrap's built-in method
      try {
        const closeBtn = modalEl.querySelector('[data-bs-dismiss="modal"]');
        if (closeBtn) {
          closeBtn.click();
        } else {
          // Fallback to programmatic close
          const inst = window.bootstrap?.Modal?.getInstance(modalEl);
          if (inst) {
            inst.hide();
          } else {
            // If no instance exists, proceed immediately
            proceedWithChatbot();
          }
        }
      } catch (error) {
        console.warn('Error closing recommended courses modal:', error);
        // Fallback: proceed anyway
        proceedWithChatbot();
      }
    } else {
      // If modal element not found, proceed immediately
      proceedWithChatbot();
    }
  };

  const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      console.error("No refresh token found.");
      return null;
    }

    try {
      // Update the endpoint to match your Django backend
      const response = await api.post("/api/token/refresh/", {
        refresh: refreshToken,
      });
      const { access } = response.data;

      if (access) {
        localStorage.setItem("authToken", access);
        return access;
      } else {
        console.error("No access token returned during refresh.");
        return null;
      }
    } catch (error) {
      console.error("Token refresh failed:", error.message);
      return null;
    }
  };
  const MAX_RETRY_ATTEMPTS = 3;

  const savedConversation = async (
    user,
    riasecCode = [],
    riasecCourses = [],
    strandCourses = [],
    riasecScores = {},
    attempt = 1,
  ) => {
    // Get the token and determine if the user is a guest
    const token = localStorage.getItem("authToken");
    const isGuest = !token;

    // Ensure user details exist before saving for guests
    const safeUser = {
      name: user?.name ? titleCase(user.name) : "Guest",
      age: isGuest && user?.age ? user.age : null, // Only include age for guests
      sex: user?.sex || "N/A",
      strand: user?.strand || "N/A",
    };

    // Prepare the request body
    const body = {
      name: safeUser.name,
      age: isGuest ? safeUser.age : undefined,
      sex: safeUser.sex,
      strand: safeUser.strand,
      riasec_code: riasecCode,
      riasec_course_recommendation: riasecCourses,
      strand_course_recommendation: strandCourses,
      realistic_score: riasecScores.realistic || 0,
      investigative_score: riasecScores.investigative || 0,
      artistic_score: riasecScores.artistic || 0,
      social_score: riasecScores.social || 0,
      enterprising_score: riasecScores.enterprising || 0,
      conventional_score: riasecScores.conventional || 0,
    };


    try {
      // Optimistic UI: show immediate saving notice and open feedback modal
      const SAVING_TEXT =
        language === "fil"
          ? "💾 Sine-save ko ang usapan mo…"
          : "💾 Saving your conversation…";
      setMessages((prev) => [
        ...prev,
        { speaks: "bot", msg: { text: { text: SAVING_TEXT } } },
      ]);
      try {
        setShowFeedbackModal(true);
      } catch {}
      // Select correct API endpoint
      const endpoint = isGuest
        ? "/api/save-guest-conversation/"
        : "/api/save-conversation/";
      const headers = isGuest ? {} : { Authorization: `Bearer ${token}` };

      // Send the request
      const response = await api.post(endpoint, body, { headers });

      if (response.status === 201) {
        console.log(
          "✅ Conversation saved successfully:",
          response.data.message,
        );

        // Replace any temporary saving message with success + rating prompt
        setMessages((prev) => {
          const withoutSaving = prev.filter(
            (m) =>
              m?.msg?.text?.text !== "💾 Saving your conversation…" &&
              m?.msg?.text?.text !== "💾 Sine-save ko ang usapan mo…",
          );
          return [
            ...withoutSaving,
            {
              speaks: "bot",
              msg: {
                text: {
text: "✅ Your conversation has been saved to your <a href='/results?tab=riasec' style='color: #007bff; text-decoration: underline; cursor: pointer;'>Results page</a> 😊. Let me know if you need any more help!",
                },
              },
            },
            {
              speaks: "bot",
              msg: {
                text: { text: "⭐ How would you rate this conversation?" },
              },
            },
          ];
        });

        // Ensure feedback modal remains open
        setShowFeedbackModal(true);
        setHasStartedConversation(false); // Mark conversation as finished

        // If user is logged in, complete the assessment session to decrement remaining slots
        if (!isGuest) {
          completeRiasecAssessmentSession(riasecScores); // Complete the assessment session
        }
      } else {
        console.error("❌ Failed to save conversation:", response);
      }
    } catch (error) {
      // If token expired, try refreshing it and retry saving once
      if (error.response?.status === 401 && token) {
        console.warn("⚠️ Access token expired, attempting to refresh...");

        const newToken = await refreshAccessToken();
        if (!newToken) {
          console.error("❌ Failed to refresh access token.");
          return;
        }

        // Retry saving the conversation with the refreshed token
        try {
          const retryResponse = await api.post(
            "/api/save-conversation/",
            body,
            {
              headers: { Authorization: `Bearer ${newToken}` },
            },
          );

          console.log(
            "✅ Conversation saved successfully after token refresh:",
            retryResponse.data.message,
          );

          // Replace temporary saving message with success + rating prompt
          setMessages((prev) => {
            const withoutSaving = prev.filter(
              (m) =>
                m?.msg?.text?.text !== "💾 Saving your conversation…" &&
                m?.msg?.text?.text !== "💾 Sine-save ko ang usapan mo…",
            );
            return [
              ...withoutSaving,
              {
                speaks: "bot",
                msg: {
                  text: {
text: "✅ Your conversation has been saved to your <a href='/results?tab=riasec' style='color: #007bff; text-decoration: underline; cursor: pointer;'>Results page</a> 😊. Let me know if you need any more help!",
                  },
                },
              },
              {
                speaks: "bot",
                msg: {
                  text: { text: "⭐ How would you rate this conversation?" },
                },
              },
            ];
          });

          setShowFeedbackModal(true);
          setHasStartedConversation(false); // Mark conversation as finished

          // Complete the assessment session to decrement remaining slots
          completeRiasecAssessmentSession(riasecScores); // Complete the assessment session
        } catch (retryError) {
          console.error(
            "❌ Error saving conversation after token refresh:",
            retryError.response?.data || retryError.message,
          );
        }
      } else if (attempt < MAX_RETRY_ATTEMPTS) {
        console.warn(`Retry attempt ${attempt + 1} for saving conversation...`);
        // Wait for 2 seconds before retrying
        await new Promise((resolve) => setTimeout(resolve, 2000));
        return savedConversation(
          user,
          riasecCode,
          riasecCourses,
          strandCourses,
          riasecScores,
          attempt + 1,
        );
      } else {
        console.error(
          "❌ Error saving conversation after maximum retry attempts:",
          error.response?.data || error.message,
        );
        // Replace any temporary saving message with a failure notice
        setMessages((prev) => {
          const withoutSaving = prev.filter(
            (m) =>
              !m?.msg?.text?.text ||
              (m.msg.text.text !== "💾 Saving your conversation…" &&
                m.msg.text.text !== "💾 Sine-save ko ang usapan mo…"),
          );
          return [
            ...withoutSaving,
            {
              speaks: "bot",
              msg: {
                text: {
                  text:
                    language === "fil"
                      ? "❌ Paumanhin, hindi ko maisave ang usapan ngayon. Maaari mong subukan muli sa Results page."
                      : "❌ Sorry, I could not save your conversation right now. You can try again from the Results page.",
                },
              },
            },
          ];
        });
      }
    }
  };

  const handleExpand = (category) => {
    setExpandedCourses((prev) => ({
      ...prev,
      [category]: (prev[category] || 5) + 5, // Increase by 5 per click
    }));
  };
  const toggleCourseVisibility = () => {
    setVisibleCourses((prev) =>
      prev >= MAX_VISIBLE_COURSES ? DEFAULT_VISIBLE_COURSES : prev + 10,
    );
  };

  // Complete RIASEC assessment session (replaces incrementChatbotStarts)
  const completeRiasecAssessmentSession = async (riasecScores) => {
    try {
      const accessToken = localStorage.getItem("authToken");
      if (!accessToken) {
        console.error('❌ No auth token found for completing assessment session');
        return;
      }

      // Get the current RIASEC session ID from backend
      const progressResponse = await api.get('/api/get-assessment-progress/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      
      if (progressResponse.status === 200 && progressResponse.data.assessment_progress) {
        const riasecProgress = progressResponse.data.assessment_progress.riasec;
        
        if (riasecProgress && riasecProgress.session_id) {
          const sessionId = riasecProgress.session_id;
          console.log(`🎯 Completing RIASEC assessment session ${sessionId}`);
          
          // Prepare completion data
          const completionData = {
            assessment_type: 'riasec',
            final_responses: {
              scores: riasecScores,
              riasec_code: riasecCode
            },
            scores: riasecScores,
            interpretation: `RIASEC scores: R=${riasecScores.realistic}, I=${riasecScores.investigative}, A=${riasecScores.artistic}, S=${riasecScores.social}, E=${riasecScores.enterprising}, C=${riasecScores.conventional}`
          };
          
          // Complete the assessment session (this will decrement the user's remaining slots)
          const response = await api.post(`/api/complete-assessment-session/${sessionId}/`, completionData);
          
          if (response.status === 200) {
            console.log('✅ RIASEC assessment session completed successfully');
            console.log('📉 User\'s remaining RIASEC slots have been decremented');
          } else {
            console.warn('⚠️ Unexpected response status:', response.status);
          }
        } else {
          console.error('❌ No active RIASEC session found for completion');
        }
      } else {
        console.error('❌ Failed to get assessment progress for completion');
      }
    } catch (error) {
      console.error(
        '❌ Error completing RIASEC assessment session:',
        error.response?.data || error.message
      );
    }
  };

  // Deprecated function - kept for reference but should not be used
  const incrementChatbotStarts = async () => {
    console.warn('⚠️ incrementChatbotStarts is deprecated. Use completeRiasecAssessmentSession instead.');
    // This function is no longer used as the new system uses assessment session completion
    // which properly decrements remaining slots when a test is completed
  };

  const renderCards = (cards) => {
    return cards.map((card, i) => <Card key={i} payload={card.structValue} />);
  };

  const renderMessage = (message, i) => {
    // The main chat's own replies and big buttons (F13)
    if (message.anna) {
      return <MainChatReply key={i} message={message} lang={language} onAction={runChatAction} />;
    }
    if (message.msg && message.msg.text && message.msg.text.text) {
      const greeting = (
        <Message
          key={i}
          keyword={message.keyword}
          terms={message.terms && message.terms}
          speaks={message.speaks}
          text={message.msg.text.text}
          userName={user?.name}
          schoolName={user?.school_name}
        />
      );
      // What's next for the student, under the greeting once the terms are agreed (N4)
      if (message.keyword === "terms-conditions" && isAgreeTermsConditions) {
        return (
          <Fragment key={i}>
            {greeting}
            <HomeCards lang={language} onAction={runChatAction} />
          </Fragment>
        );
      }
      return greeting;
    } else if (message.msg && message.msg.payload.fields.cards) {
      return (
        <Fragment key={i}>
          <div className="message-cards">
            <img
              className="chatbot-avatar message-avatar"
              src={chatbotAvatar}
              alt="chathead"
            />
            <div className="cards">
              <div
                style={{
                  width:
                    message.msg.payload.fields.cards.listValue.values.length *
                    270,
                }}
              >
                {renderCards(message.msg.payload.fields.cards.listValue.values)}
              </div>
            </div>
          </div>
          {message.msg.payload.fields.quick_replies && (
            <QuickReplies
              triggerCourseOptionYes={triggerCourseOptionYes}
              clearCourseOptionsYes={clearCourseOptionsYes}
              isCardQuickReplies={
                message.msg.payload.fields.cards ? true : false
              }
              messages={messages}
              setMessages={setMessages}
              replyClick={handleQuickReplyPayload}
              payload={
                message.msg.payload.fields.quick_replies?.listValue?.values || []
              }
            />
          )}
        </Fragment>
      );
    } else if (
      message.msg &&
      message.msg.payload &&
      message.msg.payload.fields &&
      message.msg.payload.fields.quick_replies &&
      message.msg.payload.fields.basis &&
      message.msg.payload.fields.recommended_courses_info
    ) {
      return (
        <RecommendedCoursesQuickReply
          key={i}
          payload={message.msg.payload.fields.quick_replies.listValue.values}
          basis={message.msg.payload.fields.basis.stringValue}
        />
      );
    } else if (
      message.msg &&
      message.msg.payload &&
      message.msg.payload.fields &&
      message.msg.payload.fields.quick_replies
    ) {
      return (
        <Fragment key={i}>
          {/* View Course Details Button - appears before quick replies */}
          {showViewDetailsButton && selectedCourseDetails && (
            selectedCourseDetails.is_offered !== false || (otherSchools && otherSchools.length > 0)
          ) && (
            <div
              className="message bot mb-3"
              style={{
                animation: 'fadeInUp 0.5s ease-out',
                opacity: 1,
                display: 'flex',
                alignItems: 'flex-end',
                padding: '7px 18px'
              }}
            >
              <div>
                <img
                  className="chatbot-avatar message-avatar"
                  src={chatbotAvatar}
                  alt="Anna"
                  style={{
                    width: '50px',
                    height: '50px',
                    marginRight: '10px',
                    transform: 'translateY(5px)'
                  }}
                />
              </div>
              <div
                className="message-text bot"
                style={{
                  background: selectedCourseDetails.is_offered !== false
                    ? 'linear-gradient(135deg, #f8f9fa 0%, #e8f5e8 100%)'
                    : 'linear-gradient(135deg, #fff8e1 0%, #f3e5ab 100%)',
                  border: selectedCourseDetails.is_offered !== false
                    ? '1px solid #28a745'
                    : '1px solid #ff9800',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: selectedCourseDetails.is_offered !== false
                    ? '0 2px 8px rgba(40, 167, 69, 0.1)'
                    : '0 2px 8px rgba(255, 152, 0, 0.1)',
                  padding: '15px',
                  flex: 1,
                  maxWidth: 'calc(100% - 60px)'
                }}
                onClick={() => {
                  setShowCourseDetailsModal(true);
                  setActiveSchoolTab(0); // Reset to first tab
                  if (selectedCourseDetails?.is_offered === false) {
                    fetchOtherSchools(selectedCourseDetails.course_name);
                    // Set course name color for courses not offered by current tenant
                    if (!selectedCourseDetails?.school_logo) {
                      setModalThemeColor('#ffc107'); // Bootstrap warning color (same as text-warning)
                    }
                  }
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = selectedCourseDetails.is_offered !== false
                    ? '0 4px 12px rgba(40, 167, 69, 0.2)'
                    : '0 4px 12px rgba(255, 152, 0, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = selectedCourseDetails.is_offered !== false
                    ? '0 2px 8px rgba(40, 167, 69, 0.1)'
                    : '0 2px 8px rgba(255, 152, 0, 0.1)';
                }}
              >
                <div className="d-flex align-items-start gap-3">
                  <div className={`d-flex align-items-center justify-content-center rounded-circle ${
                    selectedCourseDetails.is_offered !== false ? 'bg-success' : 'bg-warning'
                  }`} style={{ width: '35px', height: '35px', flexShrink: 0 }}>
                    <LandmarkIcon className="text-white" size={16} />
                  </div>
                  <div className="flex-grow-1">
                    <div className={`fw-bold mb-1 ${
                      selectedCourseDetails.is_offered !== false ? 'text-success' : 'text-warning'
                    }`} style={{ fontSize: '14px' }}>
                      {selectedCourseDetails.is_offered !== false ? (
                        <>
                          ✨ Great news - this program is available at {schoolDisplayName}!
                        </>
                      ) : (
                        <>
                          {otherSchools && otherSchools.length > 0 ? (
                            <>
                              ✨ This program is offered at {otherSchools.length} other school{otherSchools.length > 1 ? 's' : ''}
                            </>
                          ) : null}
                        </>
                      )}
            </div>
          
                    </div>
                    <div className="text-muted" style={{ fontSize: '12px' }}>
                      {selectedCourseDetails.is_offered !== false
                        ? 'Click to view tuition, scholarships, requirements and more!'
                        : 'Click to see which schools offer this program and their details!'
                      }
                    </div>
                  </div>
                  <div className={selectedCourseDetails.is_offered !== false ? 'text-success' : 'text-warning'} style={{ fontSize: '16px', flexShrink: 0 }}>
                    →
                  </div>
                </div>
              </div>
           
          )}
          <QuickReplies
            messages={messages}
            setMessages={setMessages}
            replyClick={handleQuickReplyPayload}
            isRiasecQuickReplies={
              message.msg.payload.fields.isriasec_quick_replies &&
              message.msg.payload.fields.isriasec_quick_replies.boolValue
            }
            payload={message.msg.payload.fields.quick_replies?.listValue?.values || []}
          />
        </Fragment>
      );
    } else if (
      message.msg &&
      message.msg.payload &&
      message.msg.payload.fields &&
      message.msg.payload.fields.basis &&
      (message.msg.payload.fields.riasec_recommended_courses ||
        message.msg.payload.fields.strand_recommended_courses)
    ) {
      return (
        <RecommendedCoursesMessage
          key={i}
          speaks={message.speaks}
          isRecommendationProvided
          handleMessagesScrollToBottom={handleMessagesScrollToBottom}
          dialogflowEventQuery={df_event_query}
          setTextMessage={setTextMessage}
          strand={user.strand}
          basis={message.msg.payload.fields.basis.stringValue}
          riasecCourses={
            message.msg.payload.fields.basis.stringValue === "riasec"
              ? riasecCourses // e.g. { artistic: [...], conventional: [...], realistic: [...] }
              : {}
          }
          recommendedCourses={
            message.msg.payload.fields.basis.stringValue === "strand"
              ? message.msg.payload.fields.strand_recommended_courses.listValue
                  .values
              : []
          }
          riasecCode={
            message.msg.payload.fields.basis.stringValue === "riasec"
              ? riasecCode
              : []
          }
          language={language}
        />
      );
    }
  };
  const renderMessages = (messages) => {
    if (messages && messages.length > 0) {
      return messages.map((message, i) => {
        return renderMessage(message, i);
      });
    } else return null;
  };

  // F13: what the student types in the main chat is read here, on the device; nothing goes to
  // Dialogflow. Worrying words are checked first (crisisPhrases.js, never overridden), then a
  // short keyword list (mainChatIntents.js). Anything else gets a kind reply with big buttons,
  // as many times as it takes: the chat never ends or locks.
  const replyTimer = useRef(null);
  useEffect(() => () => clearTimeout(replyTimer.current), []);
  const say = (anna, wait = 450) => {
    setBotChatLoading(true);
    clearTimeout(replyTimer.current);
    replyTimer.current = setTimeout(() => {
      setBotChatLoading(false);
      setMessages((prev) => [...prev, { speaks: "bot", anna }]);
    }, wait);
  };
  const send = async (e) => {
    e.preventDefault();
    const text = textMessage.trim();
    if (!text) return;
    setTextMessage("");
    setMessages((prev) => [...prev, { speaks: "user", anna: { kind: "said", text } }]);
    if (matchCrisis(text).hit) {
      say({ kind: "crisis", ...crisisReply(language) }, 250);
      return;
    }
    const found = matchIntent(text);
    // Due dates come from the shared tests list (one request, reused if it just arrived)
    const tests = found.intent === "deadline" ? await fetchMyTests().catch(() => null) : null;
    const reply = replyFor(found, { lang: language, name: firstNameOf(user?.name), tests });
    say({ kind: "reply", text: reply.text, actions: reply.actions });
  };

  /** Open one test: back to its next question when it was started, else start it. */
  const openTest = async (type) => {
    setHasAgreedToTerms(true);
    let tests = null;
    try {
      tests = await fetchMyTests({ fresh: true });
    } catch {
      tests = null;
    }
    const row = (tests || []).find((test) => test.type === type);
    // Not one they can take now (done, closed, not on their list): the test list says why
    if (row && row.status !== "open" && row.status !== "in_progress") {
      openTestPicker();
      return;
    }
    if (row && row.status === "in_progress" && Number(row.answered) > 0) {
      try {
        const response = await api.get("/api/get-assessment-progress/");
        const p = response?.data?.assessment_progress?.[type];
        if (p && p.session_id && p.status !== "completed" && p.current > 0) {
          handleResumeAssessment({
            assessment_type: type,
            session_id: p.session_id,
            current_question: p.current,
            total_questions: p.total,
            progress_percentage: p.progress_percentage,
            session_token: p.session_token,
            responses: p.responses,
            session_data: p.session_data || {},
            status: p.status || "in_progress",
          });
          return;
        }
      } catch {
        // Start it below; the test picks up its own saved answers
      }
    }
    handleConfirmAssessment(type);
  };

  /** A tap on one of Anna's buttons or home cards. */
  const runChatAction = (action) => {
    if (!action) return;
    const leave = (path) => {
      setShowbot(false);
      navigate(path);
    };
    switch (action.go) {
      case "test":
        openTest(action.test);
        break;
      case "choose":
        if (action.test) openTest(action.test);
        else openTestPicker();
        break;
      case "results":
        leave(action.test ? `/results?tab=${action.test}` : "/results");
        break;
      case "book":
        leave(action.reason ? `/book-appointment?reason=${action.reason}` : "/book-appointment");
        break;
      case "sessions":
        leave("/appointments");
        break;
      case "programs":
        leave("/programs");
        break;
      case "about": {
        const reply = replyFor({ intent: "about_tests" }, { lang: language });
        say({ kind: "reply", text: reply.text, actions: reply.actions }, 300);
        break;
      }
      default:
        break;
    }
  };

  const handleMessagesScrollToBottom = () => {
    // element.scrollTop = element.scrollHeight - element is the container of message
    // for automatic scoll when new message -> messagesRef.current.scrollTop = messagesRef.current.scrollHeight
    // for smooth scrolling, added scroll-behavior: smooth in css for chatbot-messaes class
    // if (messagesRef.current) messagesRef.current.scrollIntoView({ behavior: 'smooth' });
    if (messagesRef.current) {
      const element = messagesRef.current;
      const scrollHeight = element.scrollHeight;

      // Use smooth scrolling for better UX
      element.scrollTo({
        top: scrollHeight,
        behavior: "smooth",
      });

      // Backup scroll method with smooth behavior
      setTimeout(() => {
        if (messagesRef.current) {
          // Try to find the last message and scroll to it smoothly
          const lastMessage = messagesRef.current.lastElementChild;
          if (lastMessage) {
            lastMessage.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }
      }, 100);
    }
  };

  const handleQuickReplyPayload = (e, payload, text) => {
    e.preventDefault(); // will only work for <a> tag or buttons submit
    e.stopPropagation(); // will only work for <a> tag or buttons submit

    // Reset course-related UI state only for specific quick replies that should clear the availability message
    // Don't clear for course-related quick replies or when opening course modals
    const quickRepliesThatShouldClearMessage = [
      "ISWANT_STRAND_RECOMMENDATION",
      "END_CONVERSATION",
      "RIASEC_START",
      "START_RIASEC",
      "COURSE_OPTIONS_YES"
    ];
    
    if (quickRepliesThatShouldClearMessage.includes(payload)) {
      setShowViewDetailsButton(false);
      setSelectedCourseDetails(null);

    }

    let humanSays = {
      speaks: "user",
      msg: {
        text: {
          text: text,
        },
      },
    };

    switch (payload) {
      case "COURSE_OPTIONS_YES":
        setMessages((prev) => [...prev, humanSays]);
        df_event_query("COURSE_OPTIONS_YES");
        break;

      case "RIASEC_START":
      case "START_RIASEC":
        setMessages((prev) => [...prev, humanSays]);
        setTestStarted(true);
        setShowProgressIndicator(true);
        setCurrentStep(1);
        setTotalSteps(42);
        df_event_query("RIASEC_START");
        break;

      case "START_DASS42":
        setMessages((prev) => [...prev, humanSays]);
        setCurrentAssessmentView('dass42');
        break;

      case "ISLEARN_RIASEC_RECOMMENDED_COURSES_YES":
        setMessages((prev) => [...prev, humanSays]);
        setTextMessage(""); // Clear any residual course name from input field
        setShowViewDetailsButton(false); // Hide details button when opening new modal
        df_event_query("ISLEARN_RIASEC_RECOMMENDED_COURSES_YES");
        break;

      case "ISWANT_STRAND_RECOMMENDATION":
        setMessages((prev) => [...prev, humanSays]);
        df_event_query("ISWANT_STRAND_RECOMMENDATION");
        break;

      case "ISLEARN_STRAND_RECOMMENDED_COURSES_YES":
        setMessages((prev) => [...prev, humanSays]);
        setTextMessage(""); // Clear any residual course name from input field
        setShowViewDetailsButton(false); // Hide details button when opening new modal
        df_event_query("ISLEARN_STRAND_RECOMMENDED_COURSES_YES");
        break;

      case "END_CONVERSATION":
        setMessages((prev) => [...prev, humanSays]);
        df_event_query("END_CONVERSATION");
        break;

      default:
        // Old Dialogflow quick replies; typed text no longer goes to Dialogflow (F13)
        break;
    }
  };

  const handleResolveAfterXSeconds = (x) => {
    setBotChatLoading(true);
    return new Promise((resolve) => {
      setTimeout(() => {
        setBotChatLoading(false);
        resolve(x);
      }, x * 1000);
    });
  };

  // Custom function to close the terms and conditions modal
  const closeTermsModal = () => {


    // Method 1: Trigger the close button click
    const closeButton = document.querySelector(
      '#modal-terms-conditions [data-bs-dismiss="modal"]',
    );
    if (closeButton) {

      closeButton.click();
      return;
    }

    // Method 2: Try Bootstrap modal API
    const modal = document.getElementById("modal-terms-conditions");
    if (modal && window.bootstrap && window.bootstrap.Modal) {
      try {
        const bootstrapModal = new window.bootstrap.Modal(modal);
        bootstrapModal.hide();

      } catch (error) {

      }
    }

    // Method 3: Force close with custom event
    if (modal) {
      const closeEvent = new Event("click");
      const dismissButton = modal.querySelector('[data-bs-dismiss="modal"]');
      if (dismissButton) {
        dismissButton.dispatchEvent(closeEvent);

      }
    }
  };

  // Function to show available tests after terms agreement
  const showAvailableTests = async (userName = null) => {
    try {
      // Create welcome message
      const welcomeText = userName
        ? (language === "fil"
          ? `Kumusta ${userName}! Maligayang pagbabalik 😊. Narito ang mga available na tests para sa iyo:`
          : `Hello ${userName}! Welcome back 😊. Here are the available tests for you:`)
        : (language === "fil"
          ? "Kumusta! 👋 Narito ang mga available na tests:"
          : "Hello! 👋 Here are the available tests:");

      const welcomeMessage = {
        speaks: "bot",
        msg: { text: { text: welcomeText } },
      };

      // Create test options message with quick replies
      const testOptionsMessage = {
        speaks: "bot",
        msg: {
          payload: {
            fields: {
              quick_replies: {
                listValue: {
                  values: [
                    {
                      structValue: {
                        fields: {
                          title: { stringValue: language === "fil" ? "RIASEC Test" : "RIASEC Test" },
                          payload: { stringValue: "START_RIASEC" }
                        }
                      }
                    },
                    {
                      structValue: {
                        fields: {
                          title: { stringValue: language === "fil" ? "DASS-42 Test" : "DASS-42 Test" },
                          payload: { stringValue: "START_DASS42" }
                        }
                      }
                    },
                    {
                      structValue: {
                        fields: {
                          title: { stringValue: language === "fil" ? "Ryff Scale Test" : "Ryff Scale Test" },
                          payload: { stringValue: "START_RYFF" }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      };

      // Add messages to chat
      setMessages((prev) => [...prev, welcomeMessage, testOptionsMessage]);
      setHasStartedConversation(true);
      
    } catch (error) {
      console.error("Error showing available tests:", error);
      
      // Fallback to RIASEC only
      const fallbackMessage = {
        speaks: "bot",
        msg: {
          text: {
            text: language === "fil"
              ? "Simulan natin ang RIASEC test!"
              : "Let's start with the RIASEC test!"
          }
        }
      };
      
      setMessages((prev) => [...prev, fallbackMessage]);
      setTestStarted(true);
      setHasStartedConversation(true);
      setShowProgressIndicator(true);
      setCurrentStep(1);
      df_event_query("RIASEC_START");
    }
  };

  // Handler for confirming assessment selection
  // Starting or resuming a test: a launch screen (TestLaunch) covers the chat from the tap until
  // the test's first messages are ready (onReady), shown long enough that it never just flashes
  const [launchingTest, setLaunchingTest] = useState(null);
  const [a11yPrefs] = useA11yPrefs();
  const quickTourOpen = useQuickTourOpen();
  // Turning Larger text on or off keeps the latest message in view
  useEffect(() => {
    const element = messagesRef.current;
    if (!element) return undefined;
    const id = window.requestAnimationFrame(() => {
      element.scrollTop = element.scrollHeight;
    });
    return () => window.cancelAnimationFrame(id);
  }, [a11yPrefs.largeText]);
  const [launchPending, setLaunchPending] = useState(false);
  const launchAt = useRef(0);
  const launchRun = useRef(0);
  const withLaunch = async (type, run) => {
    launchRun.current += 1;
    const id = launchRun.current;
    launchAt.current = Date.now();
    setLaunchingTest(type || null);
    setLaunchPending(true);
    window.setTimeout(() => { if (launchRun.current === id) setLaunchingTest(null); }, 15000);
    try {
      await run();
    } finally {
      setLaunchPending(false);
    }
  };
  const handleTestReady = () => {
    const id = launchRun.current;
    const wait = Math.max(0, 700 - (Date.now() - launchAt.current));
    window.setTimeout(() => { if (launchRun.current === id) setLaunchingTest(null); }, wait);
  };
  // Started, but no test view came up (the start failed, or the old RIASEC chat): drop the screen
  useEffect(() => {
    if (launchingTest && !launchPending && !['dass42', 'sdq', 'ryff', 'riasec'].includes(currentAssessmentView)) {
      setLaunchingTest(null);
    }
  }, [launchingTest, launchPending, currentAssessmentView]);

  const handleConfirmAssessment = (assessmentType) => withLaunch(assessmentType, () => confirmAssessmentStart(assessmentType));
  const confirmAssessmentStart = async (assessmentType) => {
    
      // Check if there's a completed session for this assessment type and force fresh start
  try {
    const accessToken = localStorage.getItem("authToken");
    if (accessToken) {
      const response = await api.get("/api/get-assessment-progress/", {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      
      if (response.status === 200 && response.data.assessment_progress) {
        const progress = response.data.assessment_progress[assessmentType];
        const isAwaitingRecommendations = progress?.session_data?.awaiting_recommendations === true;
                  // Every answer saved but no result yet is finished by the test chat, not restarted (F7)
                  if (progress && !answersComplete(progress, progress.total) && (progress.status === 'completed' || ((progress.current >= progress.total || progress.progress_percentage >= 100) && !isAwaitingRecommendations))) {
            console.log(`Assessment ${assessmentType} already completed, forcing fresh start`);
            // Force start over for completed assessments
            setForceStartOver(true);
            // (A force_new_<test> flag used to be written to localStorage here; nothing
            // read it, since forceStartOver above already asks for a new session.)
          }
      }
    }
  } catch (error) {
    console.log('Error checking assessment completion status:', error);
  }
  
  // Skip localStorage checks - rely on backend only
  console.log(`📊 Skipping localStorage checks for ${assessmentType} - using backend only`);
    
    // Create user selection message
    const assessmentNames = {
      riasec: "RIASEC Test",
      dass42: "DASS-42 Test",
      ryff: "Ryff Scale",
      sdq: "SDQ Test"
    };
    
    const userMessage = {
      speaks: "user",
      msg: {
        text: {
          text: forceStartOver && assessmentType === 'riasec'
            ? `Start over the ${assessmentNames[assessmentType] || assessmentType.toUpperCase()}`
            : `I want to take the ${assessmentNames[assessmentType] || assessmentType.toUpperCase()}`
        }
      }
    };
    
    // Tests on the test shell open behind the launch screen, so no "I want to take…" bubble
    if (assessmentType === 'riasec' && !RIASEC_ON_SHELL) setMessages((prev) => [...prev, userMessage]);
    
    // Start assessment session for progress tracking
    try {
      const totalQuestions = {
        riasec: 42,
        dass42: 42,
        ryff: 42,
        sdq: 25
      };
      
      // Check if we need to force a new session using sessionStorage for all types
      // Also check if existing assessment sessions is empty (cleared by start over)
      const forceNew = forceStartOver || 
                      sessionStorage.getItem(`force_new_${assessmentType}`) === 'true' ||
                      (existingAssessmentSessions.length === 0 && forceStartOver);
      console.log(`🔍 Force new session check for ${assessmentType}:`, { 
        forceNew,
        forceStartOver
      });
      
      // Always force new session for completed assessments
      if (forceNew) {
        console.log(`🚀 Forcing new session creation for ${assessmentType}`);
      }
      
      console.log(`🚀 Making API call to start-assessment-session for ${assessmentType} with force_new=${forceNew}`);
      const response = await api.post('/api/start-assessment-session/', {
        assessment_type: assessmentType,
        total_questions: totalQuestions[assessmentType],
        dialogflow_user_id: assessmentType === 'riasec' ? cookies.get('userId') : undefined,
        force_new: forceNew // Force creation of new session if previous is completed or force start over

      });
      console.log(`✅ API response for ${assessmentType}:`, response.data);
      
      // Clear the force_new flag after using it from sessionStorage
      sessionStorage.removeItem(`force_new_${assessmentType}`);
      console.log(`🧹 Cleared force_new flag for ${assessmentType} from sessionStorage`);
      
      const sessionData = response.data.session;
      
      // Skip localStorage - rely on backend session management only
      console.log(`📊 ${assessmentType} session stored in backend only, not localStorage`);
      
      if (assessmentType === 'riasec' && RIASEC_ON_SHELL) {
        // Career interests run on the test shell (ChatbotRiasec), not Dialogflow
        setForceStartOver(false);
        setCurrentAssessmentView('riasec');
      } else if (assessmentType === 'riasec') {
        // Start RIASEC test in chatbot (Dialogflow, kept while RIASEC_ON_SHELL can be switched off)
        setTestStarted(true);
        setHasStartedConversation(true);
        setShowProgressIndicator(true);
        // Always start from step 1 if forcing start over or if session is completed
        const initialStep = forceStartOver || 
                           (sessionData.current_question >= sessionData.total_questions) || 
                           (sessionData.progress_percentage >= 100) ? 1 : (sessionData.current_question + 1 || 1);
        setCurrentStep(initialStep);
        setTotalSteps(42);
        console.log('🚀 RIASEC assessment started with progress:', initialStep, '/ 42');
        
        const welcomeMessage = {
          speaks: "bot",
          msg: {
            text: {
              text: language === "fil"
                ? (!forceStartOver && sessionData.current_question > 0 && sessionData.current_question < sessionData.total_questions
                  ? `Welcome back! 😊 Nasa tanong ${sessionData.current_question + 1} ka na ng RIASEC test.`
                  : "Simulan natin ang RIASEC test! Ito ay tutulong sa pagpili ng inyong career path. 😊")
                : (!forceStartOver && sessionData.current_question > 0 && sessionData.current_question < sessionData.total_questions
                  ? `Welcome back! 😊 You're on question ${sessionData.current_question + 1} of the RIASEC test.`
                  : "Let's start the RIASEC test! This will help determine your career path. 😊")
            }
          }
        };
        
        setMessages((prev) => [...prev, welcomeMessage]);
        df_event_query(!forceStartOver && sessionData.current_question > 0 && sessionData.current_question < sessionData.total_questions ? "RIASEC_RESUME" : "RIASEC_START");
        setForceStartOver(false);
        
        // Activate warnings after 5 seconds
        setTimeout(() => {
          setWarningsActive(true);
        }, 5000);
      } else {
        // Switch to chatbot-style assessment views with session data
        console.log('Switching to assessment view:', assessmentType, 'with session:', sessionData);
        if (assessmentType === 'dass42') {
          console.log('Setting currentAssessmentView to dass42');
          setCurrentAssessmentView('dass42');
        } else if (assessmentType === 'sdq') {
          console.log('Setting currentAssessmentView to sdq');
          setCurrentAssessmentView('sdq');
          // Show global progress like DASS-42
          setShowProgressIndicator(true);
          setTotalSteps(25);
          const startStep = forceNew ? 1 : ((sessionData.current_question || 0) + 1);
          setCurrentStep(startStep);
          console.log(`📊 SDQ progress indicator set to step ${startStep}/25`);
        } else if (assessmentType === 'ryff') {
          try { setRyffSessionId(sessionData.id); } catch {}
          
          // Always check if we truly have saved responses
          const hasRealSavedResponses = sessionData.responses && 
                                       Object.keys(sessionData.responses).length > 0 &&
                                       sessionData.current_question > 0;
          
          try {
            if (forceNew || !hasRealSavedResponses) {
              // Fresh start - no saved progress
              console.log('🆕 Starting fresh RYFF session');
              setRyffSavedProgress({
                currentQuestion: 0,
                responses: {},
                scores: {}
              });
              setRyffStartIndex(0);
            } else {
              // Resume existing session with actual saved data
              console.log('📋 Resuming RYFF session with saved responses:', Object.keys(sessionData.responses || {}).length);
              const nextQuestionIndex = sessionData.current_question || 0;
              setRyffSavedProgress({
                currentQuestion: nextQuestionIndex,
                responses: sessionData.responses || {},
                scores: sessionData.scores || {}
              });
              setRyffStartIndex(nextQuestionIndex);
            }
          } catch {}
          
          console.log('Setting currentAssessmentView to ryff');
          setCurrentAssessmentView('ryff');
          // Show global progress like DASS-42
          setShowProgressIndicator(true);
          setTotalSteps(42);
          
          // Set current step based on whether we have saved progress
          const startStep = (forceNew || !hasRealSavedResponses) ? 1 : ((sessionData.current_question || 0) + 1);
          setCurrentStep(startStep);
          console.log(`📊 RYFF progress indicator set to step ${startStep}/42`);

        }
      }
    } catch (error) {
      console.error('Error starting assessment session:', error);
      
      // The server said no (closed, not assigned, no tries left, class update needed…): say so in
      // plain words and don't open the test anyway (F21). Without a connection the test still
      // opens: its first answer starts the session once the phone is back online.
      const refused = error.response ? refusalReason(error) : null;
      if (refused) {
        const data = error.response.data || {};
        const known = myTests.tests ? testsByType(myTests.tests)[assessmentType] : null;
        const text = refused === 'deadline' && known && known.status === 'closed'
          ? `${testName(assessmentType, language)}: ${closedText(known, language)}`
          : startRefusalText(refused, { lang: language, test: testName(assessmentType, language), due: data.deadline || known?.due || null, closesOn: data.closes_on || null });
        setMessages((prev) => [...prev, { speaks: "bot", msg: { text: { text } } }]);
        myTests.reload();
        return -1; // the test didn't start
      }

      // Fallback to original behavior if session creation fails
      if (assessmentType === 'riasec' && RIASEC_ON_SHELL) {
        // The shell starts its own session on the first answer
        setCurrentAssessmentView('riasec');
      } else if (assessmentType === 'riasec') {
        setTestStarted(true);
        setHasStartedConversation(true);
        setShowProgressIndicator(true);
        setCurrentStep(1);
        setTotalSteps(42);
        
        const welcomeMessage = {
          speaks: "bot",
          msg: {
            text: {
              text: language === "fil"
                ? "Simulan natin ang RIASEC test! Ito ay tutulong sa pagpili ng inyong career path. 😊"
                : "Let's start the RIASEC test! This will help determine your career path. 😊"
            }
          }
        };
        
        setMessages((prev) => [...prev, welcomeMessage]);
        df_event_query("RIASEC_START");
        
        setTimeout(() => {
          setWarningsActive(true);
        }, 5000);
      } else {
        if (assessmentType === 'dass42') {
          setCurrentAssessmentView('dass42');
        } else if (assessmentType === 'sdq') {
          setCurrentAssessmentView('sdq');
        } else if (assessmentType === 'ryff') {
          // Still set a placeholder so the Ryff component renders (not "preparing session" hang)
          setRyffSessionId(null);
          setRyffSavedProgress({ currentQuestion: 0, responses: {}, scores: {} });
          setRyffStartIndex(0);
          setCurrentAssessmentView('ryff');
        }
      }
    }
  };

  // Handler for resuming an assessment
  const handleResumeAssessment = (session) => withLaunch(session?.assessment_type, () => resumeAssessmentStart(session));

  // Start ONE unfinished test over from the resume window: close only its session (it's kept
  // as abandoned, never deleted), forget answers still waiting on this phone for it, then open
  // it fresh at question 1. Other unfinished tests keep their answers.
  const confirmRestart = async () => {
    const item = restartTarget;
    if (!item || restarting) return;
    setRestarting(true);
    setRestartError('');
    try {
      await api.post('/api/delete-assessment-session/', { assessment_type: item.key }, { skipErrorToast: true });
      discardTest(signedInUserId(), item.key);
      setExistingAssessmentSessions((sessions) => sessions.filter((s) => {
        const type = String(s.assessment_type || s.type || '').toLowerCase();
        return !(type === item.key || (item.key === 'ryff' && type.includes('ryff')));
      }));
      if (item.key === 'ryff') {
        setRyffSessionId(null);
        setRyffSavedProgress(null);
        setRyffStartIndex(0);
      }
      sessionStorage.setItem(`force_new_${item.key}`, 'true');
      setRestartTarget(null);
      setShowResumeModal(false);
      handleConfirmAssessment(item.key);
    } catch (error) {
      setRestartError(
        language === 'fil'
          ? 'Hindi ito nasimulan muli. Tingnan ang koneksyon mo at subukan ulit.'
          : "We couldn't restart it. Check your connection and try again.",
      );
    } finally {
      setRestarting(false);
    }
  };
  const resumeAssessmentStart = async (session) => {
    setShowResumeModal(false);
    
    const assessmentType = session.assessment_type;
    const assessmentNames = {
      riasec: "RIASEC Test",
      dass42: "DASS-42 Test",
      ryff: "Ryff Scale",
      sdq: "SDQ Test"
    };
    
    // Create user resume message
    const userMessage = {
      speaks: "user",
      msg: {
        text: {
          text: `Resume ${assessmentNames[assessmentType] || assessmentType.toUpperCase()}`
        }
      }
    };
    
    // Tests on the test shell open behind the launch screen, so no "I want to take…" bubble
    if (assessmentType === 'riasec' && !RIASEC_ON_SHELL) setMessages((prev) => [...prev, userMessage]);
    
    if (assessmentType === 'riasec' && RIASEC_ON_SHELL) {
      // The shell reads the saved answers and picks up on the next question (or shows the result)
      setCurrentAssessmentView('riasec');
    } else if (assessmentType === 'riasec') {
      // Check if session is awaiting recommendations (all questions answered but recommendations not yet generated)
      const isAwaitingRecommendations = session.session_data?.awaiting_recommendations === true;
      
      if (isAwaitingRecommendations && session.current_question === 42) {
        // Special case: Resume to recommendations phase, not questions
        console.log('🎯 Resuming RIASEC at recommendations phase (all 42 questions completed)');
        
        setTestStarted(true);
        setHasStartedConversation(true);
        setShowProgressIndicator(true);
        setShowRecommendationsPhase(true);
        setCurrentStep(42);
        setTotalSteps(42);
        
        // Restore RIASEC scores from session_data
        if (session.session_data?.riasec_scores) {
          const savedScores = session.session_data.riasec_scores;
          console.log('🔄 Restoring RIASEC scores from session:', savedScores);
          setRiasec(savedScores);
          
          // Add welcome back message
          const welcomeMessage = {
            speaks: "bot",
            msg: {
              text: {
                text: language === "fil"
                  ? "Welcome back! 😊 Natapos mo na ang lahat ng 42 tanong. Bumubuo ako ng iyong mga rekomendasyon..."
                  : "Welcome back! 😊 You've completed all 42 questions. Let me generate your recommendations..."
              }
            }
          };
          setMessages((prev) => [...prev, welcomeMessage]);
          
          // Regenerate recommendations with saved scores
          handleRiasecRecommendation(savedScores);
          setIsRecommendationProvided((prev) => ({ ...prev, riasec: 'done' }));
        } else {
          console.error('❌ No RIASEC scores found in session_data, cannot resume recommendations');
        }
        
        setTimeout(() => {
          setWarningsActive(true);
        }, 5000);
      } else {
        // Normal resume: Continue from where user left off in questions
        setTestStarted(true);
        setHasStartedConversation(true);
        setShowProgressIndicator(true);
        setCurrentStep(session.current_question + 1); // Set to next question to answer
        setTotalSteps(42);
        
        // Restore question text from session responses
        if (session.responses?.last_question_text) {
          setCurrentQuestionText(session.responses.last_question_text);
          console.log('📖 Restored question text from session:', session.responses.last_question_text);
        }
        
        // Restore cumulative scores so resumed answers continue from the right baseline
        if (session.session_data?.scores) {
          setRiasec(session.session_data.scores);
          console.log('🔄 Restored RIASEC scores from session_data.scores:', session.session_data.scores);
        } else {
          console.log('ℹ️ No saved RIASEC score snapshot found in session_data.scores');
        }
        
        // Fetch resume event with session data - include next question text if available
        const resumeParams = {
          current_question: session.current_question,
          responses: session.responses || {}
        };
        
        // Include next question text if available in session data
        if (session.session_data?.next_question_text) {
          resumeParams.next_question_text = session.session_data.next_question_text;
          console.log('📝 Including next question text in resume:', session.session_data.next_question_text);
        }
        
        console.log('Frontend sending resume params:', resumeParams);
        console.log('Session data:', session);
        await df_event_query("RIASEC_RESUME", resumeParams);
        
        setTimeout(() => {
          setWarningsActive(true);
        }, 5000);
      }
    } else {
      // Switch to assessment view with session data - no localStorage usage
      if (assessmentType === 'dass42') {
        setCurrentAssessmentView('dass42');
        setShowProgressIndicator(true);
        setTotalSteps(42);
        setCurrentStep((session.current_question || 0) + 1);
      } else if (assessmentType === 'sdq') {
        setCurrentAssessmentView('sdq');
        setShowProgressIndicator(true);
        setTotalSteps(25);
        setCurrentStep((session.current_question || 0) + 1);
      } else if (assessmentType === 'ryff') {
        try { setRyffSessionId(session.session_id || session.id); } catch {}
        try {
          const resumeIndex = session.current_question || 0;
          setRyffSavedProgress({
            currentQuestion: resumeIndex,
            responses: session.responses || {},
            scores: session.session_data?.scores || {}
          });
          setRyffStartIndex(resumeIndex);
        } catch {}
        setCurrentAssessmentView('ryff');
        setShowProgressIndicator(true);
        setTotalSteps(42);
        setCurrentStep((session.current_question || 0) + 1);
      }
    }
  };

  // Check for existing assessment sessions to resume
  const checkForExistingAssessmentSessions = async () => {
    try {
      const accessToken = localStorage.getItem("authToken");
      if (!accessToken) {
        console.log('No access token found, skipping session check');
        return false;
      }
      
      // Check if there are any available assessments to check
      if (!availableAssessments || availableAssessments.length === 0) {
        console.log('No available assessments, skipping session check');
        return false;
      }

      // Query existing assessment sessions without creating new ones
      const activeSessions = [];
      
      // Which tests are assigned decides between going straight back and the Resume window; ask
      // for it alongside the progress instead of after it
      const assignedRequest = api
        .get("/api/check_login_status/")
        .then((status) => status?.data?.user_data?.assigned_assessments || null)
        .catch(() => null);
      // Which of those can still be started comes from the server (useMyTests.js)
      const serverTestsRequest = myTests.reload().catch(() => null);

      try {
        const response = await api.get("/api/get-assessment-progress/", {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        
        if (response.status === 200) {
          const data = response.data;
          
          // Handle normal "no sessions found" response
          if (data.found === false || data.message === "No assessment session found for this user") {
            console.log('📋 No assessment sessions found for user - this is normal for new users');
            return false;
          }
          
          // Check for existing sessions from the progress data
          if (data.assessment_progress) {
            for (const [assessmentType, progress] of Object.entries(data.assessment_progress)) {
              // Only include sessions that are not completed and have progress
              // Additional check: ensure current question doesn't exceed total questions (completed)
              // Also check that progress percentage is not 100% or more (completed)
              // A test with every answer saved but never sent is resumed too: it finishes at once (F7)
              if (progress.session_id && progress.current > 0 && progress.status !== 'completed' &&
                  ((progress.current < progress.total && progress.progress_percentage < 100) || answersComplete(progress, progress.total))) {
                console.log(`Found ${assessmentType} session with progress:`, progress);
                activeSessions.push({
                  assessment_type: assessmentType,
                  session_id: progress.session_id,
                  current_question: progress.current,
                  total_questions: progress.total,
                  progress_percentage: progress.progress_percentage,
                  session_token: progress.session_token,
                  responses: progress.responses,
                  session_data: progress.session_data || {}, // Include session_data for next_question_text
                  status: progress.status || 'in_progress',
                  updated_at: progress.updated_at || null, // the Resume window leads with the test used last
                });
              } else {
                console.log(`Skipping ${assessmentType} session - Status: ${progress.status}, Current: ${progress.current}, Total: ${progress.total}, Progress: ${progress.progress_percentage}`);
              }
            }
          }
        }
      } catch (error) {
        // Only log actual errors, not normal API responses
        const errorMessage = error?.response?.data?.message || error?.message;
        
        if (errorMessage === "No assessment session found for this user") {
          console.log('📋 No assessment sessions found - this is normal for new users');
        } else {
          console.log('Error checking assessment progress:', errorMessage || error);
        }
      }

      // (A second lookup by the old Dialogflow cookie id used to run here on every open with
      // nothing unfinished. Career interests run on the test shell, whose sessions the progress
      // call above already returns. N13)
      
      console.log('Active sessions with answers:', activeSessions);
      console.log('🐛 DEBUG: activeSessions detailed check:');
      activeSessions.forEach((session, index) => {
        console.log(`  Session ${index}:`, {
          assessment_type: session.assessment_type,
          current_question: session.current_question,
          status: session.status,
          progress_percentage: session.progress_percentage,
          session_id: session.session_id
        });
      });

      if (activeSessions.length > 0) {
        console.log('Setting resume modal to show');
        console.log('📋 Sessions to show in resume modal:', activeSessions.map(s => ({
          type: s.assessment_type,
          id: s.session_id,
          current: s.current_question,
          total: s.total_questions,
          progress: s.progress_percentage,
          status: s.status
        })));
        setExistingAssessmentSessions(activeSessions);
        
        // Only one test to do: go straight back to its question. Other assigned tests left too
        // (or several unfinished): ask in the Resume window whether to continue or take another.
        // The delay lets the terms dialog close.
        setTimeout(async () => {
          // Asked for alongside the progress (above); keep the list we have if it failed
          const assigned = (await assignedRequest) || availableAssessments || [];
          const startedTypes = activeSessions.map((s) => String(s.assessment_type).toLowerCase());
          const serverTests = await serverTestsRequest;
          const otherToTake = Array.isArray(serverTests)
            ? serverTests.some((test) => !startedTypes.includes(test.type) && ['open', 'in_progress'].includes(test.status))
            : assigned.some((type) => !startedTypes.includes(type) && startsLeft(user, type) !== 0);
          if (activeSessions.length === 1 && !otherToTake) {
            handleResumeAssessment(activeSessions[0]);
          } else {
            setShowResumeModal(true);
          }
        }, 200);
        
        // (Each session, answers included, used to be copied to localStorage as
        // assessment_session_<test>. Nothing read it back: resume uses the server's copy.)

        // Return true to indicate active sessions were found
        return true;
      } else {
        console.log('No active sessions found, skipping resume modal');
        setShowResumeModal(false);
        
        // Return false to indicate no active sessions
        return false;
      }
    } catch (error) {
      console.error('Error checking for existing assessment sessions:', error);
      return false;
    }
  };

  // Function to check global deadlines for assessments
  const checkGlobalDeadlines = async (assessments) => {
    setDeadlineChecking(true);
    const messages = {};
    
    try {
      // All at once rather than one after another
      await Promise.all(assessments.map(async (assessmentType) => {
        try {
          const response = await api.get(`/api/check-global-deadline/${assessmentType}/`);
          if (response.data.is_past_deadline) {
            messages[assessmentType] = response.data.deadline_message;
          }
        } catch (error) {
          console.error(`Error checking deadline for ${assessmentType}:`, error);
        }
      }));
      setDeadlineMessages(messages);
    } catch (error) {
      console.error("Error checking global deadlines:", error);
    } finally {
      setDeadlineChecking(false);
    }
  };

  // Function to fetch user's assigned assessments
  const fetchUserAssignedAssessments = async () => {
    try {
      const accessToken = localStorage.getItem("authToken");
      if (!accessToken) {
        console.warn("No access token found. Setting default assessments.");
        setAvailableAssessments(['riasec']);
        return;
      }

      const response = await api.get("/api/check_login_status/", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.status === 200 && response.data.is_logged_in) {
        const userAssignedAssessments = response.data.user_data.assigned_assessments || ['riasec'];

        // Keep all assigned assessments but store user's max_chatbot_starts for modal rendering
        setAvailableAssessments(userAssignedAssessments);
        console.log("Fetched user assigned assessments:", userAssignedAssessments);

        // Fetch current max_chatbot_starts for the logged-in user (from custom_auth_user), while
        // the deadlines are checked
        const deadlinesChecked = checkGlobalDeadlines(userAssignedAssessments);
        try {
          // The sign-in check above already carries the starts left; ask again only when it doesn't (N13)
          const fromLogin = response.data.user_data.max_chatbot_starts;
          const mcs = fromLogin !== undefined && fromLogin !== null
            ? fromLogin
            : (await api.get('/api/check-max-chatbot-starts/', {
              headers: { Authorization: `Bearer ${accessToken}` }
            }))?.data?.max_chatbot_starts;
          if (mcs !== undefined && mcs !== null) {
            setUser(prev => ({ ...prev, max_chatbot_starts: mcs }));
            try {
              localStorage.setItem('max_chatbot_starts', JSON.stringify(mcs));
            } catch {}
            console.log('[fetchUserAssignedAssessments] max_chatbot_starts loaded for modal');
          } else {
            console.warn('[fetchUserAssignedAssessments] max_chatbot_starts missing in API response');
          }
        } catch (e) {
          console.warn('Failed to fetch max_chatbot_starts:', e?.message || e);
        }

        // Deadlines for all assigned assessments (started above)
        await deadlinesChecked;
      } else {
        console.warn("User not logged in. Setting default assessments.");
        setAvailableAssessments(['riasec']);
      }
    } catch (error) {
      console.error("Error fetching user assigned assessments:", error);
      setAvailableAssessments(['riasec']);
    }
  };

  const handleTermsConditionAgree = async () => {

    setHasAgreedToTerms(true); // Set local agreement state
    setIsAgreeTermsConditions(true); // Keep existing state for compatibility
    rememberTerms(); // Not asked again this school year on this device

    // Close the modal immediately
    setTimeout(() => {
     
      closeTermsModal();
    }, 100);

    // Check for existing assessment sessions to resume after closing modal; Anna shows she's
    // working while it does
    setBotChatLoading(true);
    let hasActiveSessions = false;
    try {
      hasActiveSessions = await checkForExistingAssessmentSessions();
    } finally {
      setBotChatLoading(false);
    }
    
    // If there are active sessions, don't proceed with the rest of the flow
    if (hasActiveSessions) {
      return;
    }

    // Every path below ends in the test picker, so open it now and let it fill in
    setPickerLoading(true);
    setShowAssessmentSelectionModal(true);
    myTests.reload();

    try {
      // Get tokens from localStorage
      let accessToken = localStorage.getItem("authToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken) {
        console.warn("No access token found. Proceeding as guest.");
        // For guests, show modal with default assessments
        setAvailableAssessments(['riasec']);
        setPickerLoading(false); // the picker is already open; its list is ready now
        return;
      }

      // Function to check login status
      const checkLoginStatus = async (token) => {
        return await api.get("/api/check_login_status/", {
          headers: { Authorization: `Bearer ${token}` },
        });
      };

      // Function to check chatbot starts limit
      const checkMaxChatbotStarts = async (token) => {
        const response = await api.get("/api/check-max-chatbot-starts/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        return response;
      };

      // Function to check global deadline for a specific assessment
      const checkGlobalDeadline = async (assessmentType) => {
        try {
          const response = await api.get(`/api/check-global-deadline/${assessmentType}/`);
          return response.data;
        } catch (error) {
          console.error(`Error checking global deadline for ${assessmentType}:`, error);
          return { is_past_deadline: false, deadline_message: null };
        }
      };

      let response = await checkLoginStatus(accessToken);

      // Refresh token if access token is invalid
      if (response.status === 401 && refreshToken) {
        const refreshResponse = await api.post("/api/token/refresh/", {
          refresh: refreshToken,
        });

        if (refreshResponse.status === 200) {
          const refreshData = refreshResponse.data;
          accessToken = refreshData.access;
          localStorage.setItem("authToken", accessToken);
          response = await checkLoginStatus(accessToken); // Retry with new token
        } else {
          console.warn("Failed to refresh token. Proceeding as guest.");
          localStorage.removeItem("authToken");
          localStorage.removeItem("refreshToken");
          // For guests, show modal with default assessments
          setAvailableAssessments(['riasec']);
          setPickerLoading(false); // the picker is already open; its list is ready now
          return;
        }
      }

      if (response.status === 200 && response.data.is_logged_in) {
        const data = response.data;

        // NEW LOGIC: Check assessment deadlines first, then global deadlines if needed
        const checkAssessmentDeadlines = (assessmentDeadlines, assignedAssessments) => {
          if (!assessmentDeadlines || !assignedAssessments || assignedAssessments.length === 0) {
            return { 
              hasExpired: false, 
              expiredAssessments: [], 
              assessmentsWithIndividualDeadlines: [],
              assessmentsNeedingGlobalCheck: [],
              useGlobalDeadlines: false, // Don't check global deadlines if no assessments assigned
              noAssignedTests: true // Flag to indicate no tests are assigned
            };
          }
          
          const now = new Date();
          const expiredAssessments = [];
          const assessmentsWithIndividualDeadlines = [];
          const assessmentsNeedingGlobalCheck = [];
          
          for (const assessment of assignedAssessments) {
            const deadline = assessmentDeadlines[assessment];
            if (deadline) {
              // User has individual deadline for this assessment
              assessmentsWithIndividualDeadlines.push(assessment);
              if (now > new Date(deadline)) {
                expiredAssessments.push(assessment);
              }
            } else {
              // No individual deadline, need to check global deadline
              assessmentsNeedingGlobalCheck.push(assessment);
            }
          }
          
          return {
            hasExpired: expiredAssessments.length > 0,
            expiredAssessments,
            assessmentsWithIndividualDeadlines,
            assessmentsNeedingGlobalCheck,
            allExpired: expiredAssessments.length === assessmentsWithIndividualDeadlines.length,
            useGlobalDeadlines: assessmentsNeedingGlobalCheck.length > 0 // Use global deadlines for assessments without individual deadlines
          };
        };

        const deadlineCheck = checkAssessmentDeadlines(
          data.user_data.assessment_deadlines,
          data.user_data.assigned_assessments
        );

        console.log('[Deadline Check] Results:', {
          hasExpired: deadlineCheck.hasExpired,
          expiredAssessments: deadlineCheck.expiredAssessments,
          assessmentsWithIndividualDeadlines: deadlineCheck.assessmentsWithIndividualDeadlines,
          assessmentsNeedingGlobalCheck: deadlineCheck.assessmentsNeedingGlobalCheck,
          useGlobalDeadlines: deadlineCheck.useGlobalDeadlines
        });

        // Store individual assessment deadline messages for modal display
        const individualDeadlineMessages = {};
        if (deadlineCheck.hasExpired && deadlineCheck.expiredAssessments.length > 0) {
          for (const assessment of deadlineCheck.expiredAssessments) {
            individualDeadlineMessages[assessment] = language === "fil"
              ? `Ang deadline para sa ${assessment.toUpperCase()} assessment ay lumipas na. Pakikontak ang guidance office para sa karagdagang tulong.`
              : `The deadline for ${assessment.toUpperCase()} assessment has passed. Please contact the guidance office for further assistance.`;
          }
        }
        
        // Store individual deadline messages for modal display
        setDeadlineMessages(individualDeadlineMessages);

        // If user doesn't have individual deadlines, check global deadlines
        let globalDeadlineMessages = {};
        let hasGlobalDeadlineExpired = false;
        
        // The chat start limit is checked at the same time as the deadlines
        const limitRequest = checkMaxChatbotStarts(accessToken).then(
          (result) => ({ result }),
          (error) => ({ error }),
        );
        if (deadlineCheck.useGlobalDeadlines) {
          // All at once rather than one after another
          const globalResults = await Promise.all(
            deadlineCheck.assessmentsNeedingGlobalCheck.map(async (assessmentType) => [assessmentType, await checkGlobalDeadline(assessmentType)]),
          );
          for (const [assessmentType, globalDeadlineData] of globalResults) {
            if (globalDeadlineData.is_past_deadline) {
              globalDeadlineMessages[assessmentType] = globalDeadlineData.deadline_message;
              hasGlobalDeadlineExpired = true;
            }
          }
          
          // Store global deadline messages for modal display (merge with individual ones)
          if (hasGlobalDeadlineExpired) {
            // Merge global deadline messages with existing individual ones
            setDeadlineMessages(prev => ({
              ...prev,
              ...globalDeadlineMessages
            }));
          } else {
            // Store global deadline messages for modal display
            setDeadlineMessages(prev => ({
              ...prev,
              ...globalDeadlineMessages
            }));
          }
        }

        // Check if the chatbot starts limit is reached
        const limitOutcome = await limitRequest;
        if (limitOutcome.error) throw limitOutcome.error;
        const limitResponse = limitOutcome.result;
        let sessionLimitReached = false;
        if (
          limitResponse.status === 200 &&
          limitResponse.data.is_limit_exceeded
        ) {
          // Every test used up: the picker shows "You've finished all your tests" from the
          // server's list (useMyTests.js) instead of a "Session Limit Reached" alert
          sessionLimitReached = true;
        }
        
        // Always continue with the modal flow, regardless of session limit
        // Use limitResponse payload to persist max_chatbot_starts
        const latestMaxStarts = limitResponse?.data?.max_chatbot_starts;
        setUser({
          name: data.user_data.name,
          age: data.user_data.age,
          sex: data.user_data.sex,
          strand: data.user_data.strand,
          school_name: data.user_data.school_name || null,
          current_section: data.user_data.current_section || null, // Grade / college for riasecLogic.stageOf (N5)
          max_chatbot_starts: latestMaxStarts,
          extended_deadline: data.user_data.extended_deadline,
        });
        try {
          if (latestMaxStarts !== undefined) {
            localStorage.setItem('max_chatbot_starts', JSON.stringify(latestMaxStarts));
            console.log('[AgreeToTerms] Stored max_chatbot_starts from limitResponse');
          }
        } catch {}

        // Use assigned assessments from login status data
        const userAssignedAssessments = data.user_data.assigned_assessments || ['riasec'];
        
        // Check if all assessments have expired deadlines
        const allAssessmentsExpired = userAssignedAssessments.every(assessment => {
          // Check if this assessment has an individual deadline that expired
          if (deadlineCheck.assessmentsWithIndividualDeadlines.includes(assessment)) {
            return deadlineCheck.expiredAssessments.includes(assessment);
          }
          // Check if this assessment has a global deadline that expired
          if (deadlineCheck.assessmentsNeedingGlobalCheck.includes(assessment)) {
            return globalDeadlineMessages[assessment];
          }
          return false;
        });
        
        if (allAssessmentsExpired) {
          // If all assessments have expired, show a message in the modal but still allow it to open
          console.log('[AgreeToTerms] All assessments have expired deadlines');
        }
        
        setAvailableAssessments(userAssignedAssessments);
        console.log("User assigned assessments:", userAssignedAssessments);

        // The picker is already open; its list is ready now
        setPickerLoading(false);

        // Activate warnings after 5 seconds
        setTimeout(() => {
          setWarningsActive(true);
          console.log("Warnings activated after 5 seconds");
        }, 5000);
      } else {
        console.warn("User not logged in. Proceeding as guest.");
        
        // For guests, show modal with default assessments
        setAvailableAssessments(['riasec']);
        setPickerLoading(false); // the picker is already open; its list is ready now
      }
    } catch (error) {
      console.error("Error checking user login status:", error.message);

      const errorMessageText =
        language === "fil"
          ? "Nagkaroon ng problema habang sinusuri ang iyong access. Pakisubukang muli mamaya."
          : "Something went wrong while checking your access. Please try again later.";

      const errorMessage = {
        speaks: "bot",
        msg: { text: { text: errorMessageText } },
      };

      setMessages((prev) => [...prev, errorMessage]);
      setPickerLoading(false);
      setShowAssessmentSelectionModal(false);
    }
  };

  // const fetchCoursesByStrand = async () => {
  //    try {
  //       const response = await fetch(`/user/courses-by-strand/${user.strand}`);
  //       const data = await response.json();
  //       console.log(data);
  //       if (response.status === 200) setStrandBasedRecommendedCourses(data.courses);
  //    } catch (err) {
  //       console.error(err.message);
  //    }
  // };

  useEffect(() => {

    handleMessagesScrollToBottom();
  }, [messages, showBot]);

  // Scroll to bottom when chatbot is minimized after being enlarged
  useEffect(() => {
    // Only scroll when minimizing (isEnlarged becomes false)
    if (!isEnlarged && messages.length > 0) {


      // Wait longer to ensure the resize animation completes
      const timer = setTimeout(() => {
        handleMessagesScrollToBottom();

        // Additional delay and final scroll attempt
        setTimeout(() => {
          if (messagesRef.current) {
            const element = messagesRef.current;
            const maxScroll = element.scrollHeight - element.clientHeight;
            element.scrollTo({
              top: maxScroll,
              behavior: "smooth",
            });
          }
        }, 800);
      }, 500); // Wait for CSS transition (0.3s) + buffer

      return () => clearTimeout(timer);
    }
  }, [isEnlarged, messages.length]);

  // The terms are remembered for the school year (testShell/termsMemory.js). The old
  // "termsCondition" cookie was read here but never written, so every visit asked again.
  useEffect(() => {
    setIsAgreeTermsConditions(termsRemembered());
  }, []);

  // Whenever the chat opens with an unfinished test (after a reload or "Leave for now"): only one
  // test to do goes straight back to its question; otherwise the Resume window asks whether to
  // continue or take another. With nothing unfinished, the first bubble's "Choose a test" is there.
  // Not while the quick tour shows the chat: it waits until the tour closes.
  useEffect(() => {
    if (!showBot || quickTourOpen) return;
    if (currentAssessmentView !== 'main' || testStarted) return;
    if (!localStorage.getItem("authToken") || !termsRemembered()) return;
    setHasAgreedToTerms(true);
    // /?test=<type> (Resume on Results, a home card): straight to that test (N4)
    const askedFor = takeTestRequest();
    if (askedFor) {
      openTest(askedFor);
      return;
    }
    checkForExistingAssessmentSessions();
  }, [showBot, quickTourOpen]);

  // The same request while the chat is already open on its main view
  useEffect(() => {
    const onOpenTest = () => {
      if (!showBot || quickTourOpen || currentAssessmentView !== 'main' || testStarted) return;
      if (!localStorage.getItem("authToken") || !termsRemembered()) return;
      const askedFor = takeTestRequest();
      if (askedFor) openTest(askedFor);
    };
    window.addEventListener(OPEN_TEST_EVENT, onOpenTest);
    return () => window.removeEventListener(OPEN_TEST_EVENT, onOpenTest);
  });

  // "Choose a test" on the first bubble (shown once the terms are agreed)
  useEffect(() => {
    const onChoose = () => openTestPicker();
    window.addEventListener("anna:choose-test", onChoose);
    return () => window.removeEventListener("anna:choose-test", onChoose);
  });
  useEffect(() => {
    setMessages((prevMessages) => {
      return prevMessages.map((message) =>
        message.keyword === "terms-conditions"
          ? {
              ...message,
              msg: {
                text: {
                  text:
                    language === "fil"
                      ? "Kumusta! 👋 Bago tayo magsimula, sa session na ito ay kukunin ko ang iyong pangunahing impormasyon. <strong>Kailangan mo munang basahin at sumang-ayon sa mga tuntunin</strong> na ipinakita sa"
                      : "Hello! 👋 Before we begin, in this session I will take your basic information. <strong>You must first read and agree on the terms presented in the</strong>",
                },
              },
            }
          : message,
      );
    });
  }, [language]); // Runs when language changes

  // Clear search term when recommendations modal closes
  useEffect(() => {
    const handleModalClose = () => {
      setCourseSearchTerm("");
      setVisibleCourses(DEFAULT_VISIBLE_COURSES);
    };

    // Listen for modal close events
    const modal = document.getElementById("modal-recommended-courses-info");
    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleModalClose);

      // Cleanup function
      return () => {
        modal.removeEventListener("hidden.bs.modal", handleModalClose);
      };
    }
  }, []); // Empty dependency array - only run once on mount

  // Refresh data when modal opens
  useEffect(() => {
    const modal = document.getElementById("modal-recommended-courses-info");
    if (modal) {
      const handleModalShow = () => {
        // Refresh coursesAtOtherSchools data when modal opens
        checkAllCoursesAtOtherSchools();
      };
      
      modal.addEventListener("shown.bs.modal", handleModalShow);
      
      return () => {
        modal.removeEventListener("shown.bs.modal", handleModalShow);
      };
    }
  }, [checkAllCoursesAtOtherSchools]);

  // The X and a click on the backdrop: mid-test it asks first
  const requestCloseChat = () => {
    // DASS-42, SDQ and Ryff: say the answers are saved and where the student will pick up
    if (testActiveRef.current.active) {
      setLeavePrompt({ ...testActiveRef.current });
      return;
    }
    if (['dass42', 'sdq', 'ryff', 'riasec'].includes(currentAssessmentView)) {
      leaveWithRating(closeChatAfterTest);
      return;
    }
    if (
      isAgreeTermsConditions &&
      hasStartedConversation &&
      warningsActive &&
      !endConversation
    ) {
      triggerCustomWarning();
    } else {
      setShowbot(false);
    }
  };

  if (hideChatbot) {
    return null;
  }

  return (
    <>
      {/* Dims the page behind the centred window (desktop) so the chat reads as a dialog */}
      {showBot && !isEnlarged && (
        <div className="cb-scrim" aria-hidden="true" onClick={requestCloseChat} />
      )}
      {showBot ? (
        <div
          className={`chatbot shadow ${isEnlarged ? "chatbot-enlarged" : ""} ${isAgreeTermsConditions ? 'is-terms-accepted' : ''} ${isEnlarged && showTooltip ? 'has-tooltip' : ''}${a11yPrefs.largeText ? ' is-large-text' : ''}`}
        >
          {/* chatbot header */}
          {/* Chatbot Header */}
          <div className="chatbot-header d-flex justify-content-between align-items-center bg-primary p-2">
            <div className="d-flex align-items-center">
              <img className="chatbot-avatar" src={chathead} alt="chathead" />
              <div className="ms-2">
                <h2 className="h6 d-inline custom-heading text-white mb-0">
                  Anna
                </h2>
                {/* Progress: a subtitle under the name, and a thin line along the header's bottom edge */}
                {(showProgressIndicator || isTestComplete) && (
                  <div className="progress-indicator-wrapper cb-progress">
                    {isTestComplete || showRecommendationsPhase ? (
                      <div className="cb-progress-label">
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {isTestComplete
                          ? (language === "fil" ? "Tapos na ang pagsusulit!" : "Test Complete!")
                          : (language === "fil" ? "Bumubuo ng mga rekomendasyon..." : "Generating Recommendations...")}
                      </div>
                    ) : (
                      <>
                        <div className="cb-progress-label">
                          {getAssessmentDisplayName(currentAssessmentView)}
                          <span aria-hidden="true">·</span>
                          {language === "fil"
                            ? `${currentStep} sa ${totalSteps}`
                            : `${currentStep} of ${totalSteps}`}
                        </div>
                        <div
                          className="cb-progress-track"
                          role="progressbar"
                          aria-label={language === "fil" ? "Progreso ng test" : "Test progress"}
                          aria-valuemin={0}
                          aria-valuemax={totalSteps}
                          aria-valuenow={currentStep}
                        >
                          <div
                            className="cb-progress-fill"
                            style={{ width: `${Math.min(100, (currentStep / totalSteps) * 100)}%` }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center">
              {/* Language Dropdown */}
              {false && (
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    className="language-dropdown"
                  >
                    <LanguageIcon size={24} className="white-icon" />
                    <span className="ms-2">Language</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="center">
                    <Dropdown.Item
                      onClick={() => switchLanguage("en")}
                      active={language === "en"}
                    >
                      English
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => switchLanguage("fil")}
                      active={language === "fil"}
                    >
                      Filipino (Beta)
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {/* Larger text and read aloud (testShell/A11yMenu.js) */}
              <A11yMenu language={language} />

              {/* Enlarge/Maximize Button with Tooltip */}
              <div className="position-relative">
                {/* Animated Tooltip */}
                <div 
                  className="maximize-tooltip"
                  style={{
                    position: 'absolute',
                    bottom: '35px',
                    right: '0',
                    backgroundColor: '#ffffff',
                    color: '#495057',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    zIndex: 9999, // Highest z-index to ensure it's always visible
                    opacity: (!isEnlarged || !showTooltip) ? 0 : 1,
                    transform: (!isEnlarged || !showTooltip) ? 'translateY(10px) scale(0.9)' : 'translateY(0) scale(1)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    animation: (!isEnlarged || !showTooltip) ? 'none' : 'tooltipBounce 0.6s ease-out',
                    pointerEvents: 'none',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    border: '1px solid #e9ecef'
                  }}
                >
                  {language === "fil" ? "I-click para palakihin" : "Click to make the chat bigger"}
                  <div 
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: '12px',
                      width: 0,
                      height: 0,
                      borderLeft: '6px solid transparent',
                      borderRight: '6px solid transparent',
                      borderTop: '6px solid #ffffff'
                    }}
                  />
                </div>

                {isEnlarged ? (
                  <ExpandIcon
                    className="chatbot-enlarge ms-2 white-icon d-none d-md-block"
                    size={24}
                    onClick={toggleEnlarge}
                    title="Maximize"
                  />
                ) : (
                  <CollapseIcon
                    className="chatbot-enlarge ms-2 white-icon d-none d-md-block"
                    size={24}
                    onClick={toggleEnlarge}
                    title="Minimize"
                  />
                )}
              </div>

              {/* Close Button */}
              <XIcon
                className="chatbot-close ms-3 white-icon"
                size={24}
                onClick={requestCloseChat}
              />
            </div>
          </div>

          <TestLaunch show={Boolean(launchingTest)} testKey={launchingTest} language={language} />

          {/* Conditional rendering based on current assessment view */}
          {['dass42', 'sdq', 'ryff', 'riasec'].includes(currentAssessmentView) ? (
            (() => {
            // DASS-42, SDQ and Ryff run on the shared test shell (testShell/)
            const TestView = { dass42: ChatbotDASS42, sdq: ChatbotSDQ, ryff: ChatbotRyff, riasec: ChatbotRiasec }[currentAssessmentView];
            const ryffSession = (existingAssessmentSessions || []).find(s => String(s.assessment_type || s.type).toLowerCase() === 'ryff');
            const ryffProgress = ryffSavedProgress || (ryffSession ? {
              currentQuestion: (ryffSession.current_question ?? ryffSession.current ?? 0),
              responses: ryffSession.responses || {},
            } : null);
            return (
              <TestView
                key={currentAssessmentView === 'ryff' ? `ryff-${ryffSessionId || 'none'}` : currentAssessmentView}
                language={language}
                schoolName={user?.school_name || null}
                studentName={user?.name || ''}
                nextTest={nextTestAfter(currentAssessmentView)}
                sessionId={currentAssessmentView === 'ryff' ? ryffSessionId : null}
                savedProgress={currentAssessmentView === 'ryff' ? ryffProgress : null}
                setShowProgressIndicator={setShowProgressIndicator}
                setCurrentStep={setCurrentStep}
                setTotalSteps={setTotalSteps}
                onActiveChange={(state) => {
                  testActiveRef.current = state;
                  // A test being answered or saved keeps the shared-computer sign-out away
                  setTestChatBusy(Boolean(state?.active));
                }}
                onFinished={handleTestFinished}
                onFinishAction={handleTestAction}
                onReady={handleTestReady}
                context={{ user, offerings }}
              />
            );
            })()
          ) : (
            <>
              {/* chatbot messages */}
              <div ref={messagesRef} className="chatbot-messages">
                {/* <button className='btn btn-primary' onClick={() => handleRiasecRecommendation(riasec)}>
                        Identify RIASEC Area
                    </button> */}

                {renderMessages(messages)}
                
                {/* <div ref={messageEnd}></div> */}
                {botChatLoading && (
                  <div className="message bot">
                    <div>
                      <img
                        className="chatbot-avatar message-avatar"
                        src={chatbotAvatar}
                        alt="chathead"
                      />
                    </div>
                    <div className="message-text bot">
                      <img
                        className="message-loading"
                        src={chatloading}
                        alt="loading"
                      />
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          {/* text-input (hidden during assessment views) */}
          {currentAssessmentView === 'main' && (
          <form className="chatbot-text-input" onSubmit={send}>
            {/* Always there once the terms are agreed: typing never ends or locks the chat (F13) */}
            <input
              ref={inputRef}
              className="visible"
              disabled={!isAgreeTermsConditions}
              value={textMessage}
              type="text"
              maxLength={500}
              enterKeyHint="send"
              aria-label={language === "fil" ? "Magtanong kay Anna" : "Ask Anna something"}
              placeholder={language === "fil" ? "Magtanong kay Anna…" : "Ask Anna something…"}
              onChange={(e) => setTextMessage(e.target.value)}
            />
            <button
              className="btn p-0 chatbot-send"
              disabled={!textMessage.trim()}
              type="submit"
              aria-label={language === "fil" ? "Ipadala" : "Send"}
            >
              <SendIcon className="chatbot-send text-primary visible" />
            </button>
          </form>
          )}
        </div>
      ) : (
        <ChatLauncher language={language} onOpen={() => setShowbot(true)} />
      )}

      {/* terms & conditions modal */}
      <CustomModal
        title="Terms and Conditions"
        target="modal-terms-conditions"
        size="modal-lg modal-dialog-centered"
      >
        <div className="terms-modal-container">
          {/* Fixed Header */}
          <div className="terms-modal-header">
            <h4 className="mb-0 text-primary fw-bold">
              <Icon name="clipboard-list" className="me-2" />
              Terms and Conditions
            </h4>
            <p className="text-muted mb-0 small">
              Please read and agree to continue
            </p>
          </div>

          {/* Scrollable Content */}
          <div className="terms-modal-content">
            {/* Shared with the homepage's terms (common/termsCopy.js) */}
            <AnswersCard language={language} />
            <div className="terms-section">
              <p className="terms-intro-text">
                In using Anna, you agree to these terms and conditions:
              </p>
              <ol className="terms-list-simple">
                <li>
                  All responses and correspondences with Anna will be recorded.
                </li>
                <li>
                  Information such as your name, age, sex, strand or track (if
                  any), your answers to the assessments, and related
                  correspondence will be for the exclusive use of ANNA and the
                  school to continuously improve Anna.
                </li>
                <li>
                  The data collected will be used for as long as it is needed
                  for further analysis or investigation.
                </li>
                <li>
                  You are free to exit the conversation with Anna if you feel
                  the need to do so.
                </li>
              </ol>
            </div>

            <div className="terms-section">
              <h5 className="section-title-simple">User guidelines</h5>
              {/* How ANNA really behaves (2026-10-20): no idle timer in the tests; unfinished tests keep 7 days.
                  The "Anna chats in English" line went: the chat and the tests also run in Filipino. */}
              <p>{"Take your time. There's no time limit on any question. Your answers are saved after each one, so you can stop and come back later to pick up where you left off."}</p>
              <p>{"An unfinished test stays saved until its due date. If it has no due date, come back within 7 days of your last answer, or it starts again from the first question."}</p>
              <p>{"If you're asked to sign in again after a break, your saved answers will still be there."}</p>
              <p>{"If you leave a typed chat with Anna for a while, she may lose track of it. Say \"Hi\" to start again."}</p>
              <p>
                If any problems occur during the conversation process, or you
                have any suggestions or comments you would like to share, please
                leave a feedback
                <a className="text-primary ms-1" href="/#feedback">
                  here
                </a>
                . Your insights and suggestions would help improve our project.
              </p>
            </div>

            <div className="terms-section">
              <h5 className="section-title-simple">Definitions</h5>
              <p>
                Throughout the conversation, Anna will be responding to possible
                jargons. To ensure that you understand Anna, the definition of
                words will be provided:
              </p>
              <p>
                <span className="definition-term-simple">Degree Program</span> -
                A class that a college or university offers to students.
                (Bachelor of Science in Information Technology, etc..)
              </p>
              <p>
                <span className="definition-term-simple">RIASEC</span> - A
                personality test that asks about your interest, skills, ability,
                and aspirations which will help you decide on what career to
                pursue based on these attributes.
              </p>
              <p>
                <span className="definition-term-simple">SDQ</span> - The
                Strengths and Difficulties Questionnaire. It asks about your
                behavior, your feelings and how you get along with others.
              </p>
              <p>
                <span className="definition-term-simple">DASS-42</span> - The
                Depression, Anxiety and Stress Scale. It asks how you have been
                feeling over the past week.
              </p>
              <p>
                <span className="definition-term-simple">Ryff scale</span> -
                Ryff's Scales of Psychological Well-being. It asks about six areas
                of well-being, such as purpose in life and personal growth.
              </p>
              <p>
                <span className="definition-term-simple">Strand or track</span> -
                The senior high school track a student is in, such as STEM or ABM.
                It only applies to senior high students.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="terms-modal-footer">
            {!hasAgreedToTerms ? (
              <div className="d-flex flex-column align-items-center">
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    onChange={() => handleTermsConditionAgree()}
                    type="checkbox"
                    value=""
                    id="terms-conditions-check"
                    checked={isAgreeTermsConditions}
                  />
                  <label
                    className="form-check-label fw-bold"
                    htmlFor="terms-conditions-check"
                  >
                    I agree to the terms and conditions
                  </label>
                </div>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  data-bs-dismiss="modal"
                  style={{ minWidth: "100px" }}
                >
                  Close
                </button>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center">
                <div className="text-success mb-3">
                  <i className="fas fa-check-circle"></i> Terms and Conditions
                  Accepted
                </div>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  data-bs-dismiss="modal"
                  style={{ minWidth: "100px" }}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </CustomModal>

      {/* Choose a test, then confirm it, in one dialog */}
      <AssessmentPicker
        show={showAssessmentSelectionModal}
        language={language}
        availableAssessments={availableAssessments}
        deadlineMessages={deadlineMessages}
        deadlineChecking={deadlineChecking}
        loading={pickerLoading}
        user={user}
        // Always closable: the first bubble's "Choose a test" brings it back
        canClose
        progress={pickerProgress}
        myTests={myTests.tests}
        myTestsLoading={myTests.loading}
        onTalk={() => {
          setShowAssessmentSelectionModal(false);
          navigate('/book-appointment?reason=general');
        }}
        onClose={() => {
          setShowAssessmentSelectionModal(false);
          setPickerProgress({});
          // Reset terms and conditions when closing with no assessments
          if (availableAssessments.length === 0) {
            setIsAgreeTermsConditions(false);
            setHasAgreedToTerms(false);
          }
        }}
        onResults={(assessmentType) => {
          setShowAssessmentSelectionModal(false);
          navigate(`/results?tab=${assessmentType}`);
        }}
        onStart={(assessmentType) => {
          setShowAssessmentSelectionModal(false);
          const open = pickerProgress[assessmentType];
          setPickerProgress({});
          if (open) handleResumeAssessment(open.session);
          else handleConfirmAssessment(assessmentType);
        }}
      />

      {/* Resume Assessment Modal */}
      {showResumeModal && (
        <Modal 
          show={showResumeModal} 
          onHide={() => {
            setShowResumeModal(false);
            setForceStartOver(false);
            setRestartTarget(null);
            setRestartError('');
          }}
          centered 
          size="md"
          style={{ zIndex: 1200 }}
          className="cb-resume-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {(() => {
                const first = titleCase(String(user?.name || '').trim().split(/\s+/)[0] || '');
                return first ? `Welcome back, ${first}` : 'Welcome back';
              })()}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* One clear next step: the test used last, big; any others below as quiet rows.
                Start over works on one test at a time and asks first (confirmRestart). */}
            {(() => {
              const fil = language === "fil";
              const describe = (session) => {
                let rawType = String(session.assessment_type || session.type || '').toLowerCase().trim();
                if (session.assessment_type === 'ryff') rawType = 'ryff';
                const key = rawType.includes('ryff') ? 'ryff' : rawType;
                const done = (session.current ?? session.current_question ?? 0);
                const total = (session.total ?? session.total_questions ?? 0);
                return {
                  session,
                  key,
                  name: getAssessmentDisplayName(key),
                  next: Math.min(done + 1, total),
                  total,
                  percent: Math.max(0, Math.min(100, Math.round(session.progress_percentage || 0))),
                };
              };
              const when = (session) => Date.parse(session.updated_at || '') || 0;
              const [last, ...others] = [...existingAssessmentSessions].sort((a, b) => when(b) - when(a)).map(describe);
              if (!last) return null;
              const tile = (item, size) => (assessmentKey(item.key) ? <AssessmentIcon type={item.key} size={size} /> : <Icon name="clipboard-list" size={size} />);
              // Every answer saved, only the sending left (F7)
              const allIn = (item) => item.total > 0 && (item.session.current ?? item.session.current_question ?? 0) >= item.total;
              const where = (item) => (allIn(item)
                ? (fil ? `Nasagot na ang lahat ng ${item.total}` : `All ${item.total} answered`)
                : (fil ? `Tanong ${item.next} sa ${item.total}` : `Question ${item.next} of ${item.total}`));
              const askRestart = (item) => {
                setRestartError('');
                setRestartTarget(item);
              };
              if (restartTarget) {
                const answered = Math.max(0, restartTarget.next - 1);
                const answers = fil
                  ? `${answered} mong sagot`
                  : answered === 1 ? 'your 1 answer' : `your ${answered} answers`;
                return (
                  <motion.div
                    key="restart"
                    className="rs rs-confirm"
                    initial={{ opacity: 0, x: 24 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.24, ease: [0.16, 1, 0.3, 1] }}
                  >
                    <motion.span
                      className="rs-confirm-tile"
                      initial={{ scale: 0.6, rotate: -90 }}
                      animate={{ scale: 1, rotate: 0 }}
                      transition={{ type: 'spring', stiffness: 320, damping: 18 }}
                    >
                      <Icon name="refresh" size={28} />
                    </motion.span>
                    <h3 className="rs-confirm-title">
                      {fil ? `Simulan muli ang ${restartTarget.name}?` : `Start ${restartTarget.name} over?`}
                    </h3>
                    <p className="rs-confirm-text">
                      {fil
                        ? `Mabubura ang ${answers} at magsisimula ka ulit sa tanong 1. Hindi magagalaw ang iba mong test.`
                        : `This clears ${answers} and you'll begin again at question 1. Your other tests stay as they are.`}
                    </p>
                    <AnimatePresence>
                      {restartError && (
                        <motion.p className="rs-confirm-error" role="alert" initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                          {restartError}
                        </motion.p>
                      )}
                    </AnimatePresence>
                    <div className="rs-confirm-actions">
                      <button type="button" className="rs-confirm-keep" onClick={() => setRestartTarget(null)} disabled={restarting}>
                        <Icon name="arrow-left" size={18} />
                        {fil ? 'Panatilihin ang sagot ko' : 'Keep my answers'}
                      </button>
                      <button type="button" className="rs-confirm-go" onClick={confirmRestart} disabled={restarting}>
                        {restarting ? <span className="spinner-border spinner-border-sm" aria-hidden="true" /> : <Icon name="refresh" size={18} />}
                        {restarting ? (fil ? 'Sinisimulan…' : 'Starting over…') : (fil ? 'Simulan muli' : 'Start over')}
                      </button>
                    </div>
                  </motion.div>
                );
              }
              return (
                <div className="rs">
                  <p className="rs-lead">
                    {fil
                      ? "Naka-save ang mga sagot mo. Ituloy kung saan ka huminto."
                      : "Your answers are saved. Pick up right where you stopped."}
                  </p>
                  <div className="rs-hero">
                    <div className="rs-hero-top">
                      <span className="rs-tile">{tile(last, 28)}</span>
                      <span className="rs-text">
                        {others.length > 0 && <span className="rs-tag">{fil ? "Huling binuksan" : "Last time"}</span>}
                        <span className="rs-name">{last.name}</span>
                        <span className="rs-meta">{where(last)}</span>
                      </span>
                    </div>
                    <span className="rs-bar" aria-hidden="true">
                      <i style={{ width: `${Math.max(last.percent, 3)}%` }} />
                    </span>
                    <button type="button" className="rs-continue" onClick={() => handleResumeAssessment(last.session)}>
                      <span>{allIn(last) ? (fil ? "Tapusin" : "Finish") : (fil ? "Ituloy" : "Continue")}</span>
                      <Icon name="arrow-right" size={20} />
                    </button>
                    <button type="button" className="rs-restart" onClick={() => askRestart(last)}>
                      <Icon name="refresh" size={16} />
                      {fil ? "Simulan muli ang test na ito" : "Start this test over"}
                    </button>
                  </div>
                  {others.length > 0 && (
                    <>
                      <span className="rs-label">{fil ? "Nasimulan mo rin" : "Also in progress"}</span>
                      <ul className="rs-list">
                        {others.map((item) => (
                          <li key={`${item.key}-${item.session.session_id || item.session.id}`} className="rs-item">
                            <button
                              type="button"
                              className="rs-row"
                              onClick={() => handleResumeAssessment(item.session)}
                              aria-label={fil ? `Ituloy ang ${item.name}, ${where(item)}` : `Continue ${item.name}, ${where(item)}`}
                            >
                              <span className="rs-tile is-small">{tile(item, 22)}</span>
                              <span className="rs-text">
                                <span className="rs-name">{item.name}</span>
                                <span className="rs-meta">{where(item)}</span>
                              </span>
                              <span className="rs-ring" style={{ '--p': `${item.percent}%` }} aria-hidden="true" />
                              <Icon name="chevron-right" size={18} />
                            </button>
                            <button
                              type="button"
                              className="rs-row-restart"
                              onClick={() => askRestart(item)}
                              aria-label={fil ? `Simulan muli ang ${item.name}` : `Start ${item.name} over`}
                              title={fil ? "Simulan muli" : "Start over"}
                            >
                              <Icon name="refresh" size={18} />
                            </button>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              );
            })()}
          </Modal.Body>
          {!restartTarget && (
            <Modal.Footer className="rs-foot">
              <button
                type="button"
                className="rs-link"
                onClick={() => {
                  setShowResumeModal(false);
                  setForceStartOver(false);
                  openTestPicker();
                }}
              >
                {language === "fil" ? "Pumili ng ibang test" : "Take a different test"}
              </button>
            </Modal.Footer>
          )}
        </Modal>
      )}

      {/* Start Over Confirmation Modal */}
      {showStartOverConfirm && (
        <Modal
          show={showStartOverConfirm}
          onHide={() => {
            setShowStartOverConfirm(false);
            setShowResumeModal(true);
          }}
          centered
          size="md"
          style={{ zIndex: 1420 }}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {language === 'fil' ? 'Kumpirmahin ang Simulang Muli' : 'Confirm Start Over'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="am-intro">
              <span className="am-intro-icon is-warning">
                <Icon name="refresh" size={28} />
              </span>
              <h3 className="am-intro-title">
                {language === 'fil' ? 'Simulan muli?' : 'Start over?'}
              </h3>
              <p className="am-intro-text">
                {language === 'fil'
                  ? 'Sigurado ka bang gusto mong simulan muli? Matatanggal ang kasalukuyang assessment session.'
                  : 'Are you sure you want to start over? Your current assessment session will be deleted.'}
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="am-foot-split">
              <button
                type="button"
                className="am-btn"
                onClick={() => {
                  setShowStartOverConfirm(false);
                  setShowResumeModal(true);
                }}
              >
                <Icon name="arrow-left" size={18} />
                {language === 'fil' ? 'Bumalik' : 'Back'}
              </button>
              <button
                type="button"
                className="am-btn is-primary"
                onClick={async () => {
                  setForceStartOver(true);
                  // Set flags to force new sessions for all assessment types
                  sessionStorage.setItem('force_new_ryff', 'true');
                  sessionStorage.setItem('force_new_riasec', 'true');
                  sessionStorage.setItem('force_new_dass42', 'true');
                  console.log('🚁 Set force_new flags for all assessment types');
                  
                  try {
                    // Clear all assessment sessions using the new clear_all endpoint
                    console.log('🗑️ Clearing all assessment sessions for user...');
                    const clearResponse = await api.post('/api/delete-assessment-session/', { 
                      clear_all: true 
                    });
                    console.log('✅ Successfully cleared all assessment sessions:', clearResponse.data.message);
                    
                    // Clear frontend assessment session state
                    setExistingAssessmentSessions([]);
                    
                    // Clear all Ryff-specific state
                    setRyffSessionId(null);
                    setRyffSavedProgress(null);
                    setRyffStartIndex(0);
                    
                    // Clear all session storage flags
                    sessionStorage.removeItem('force_new_ryff');
                    sessionStorage.removeItem('force_new_riasec');
                    sessionStorage.removeItem('force_new_dass42');
                    console.log('🧹 Cleared all force_new flags from sessionStorage');
                    console.log('🧹 Cleared frontend assessment state');
                    
                  } catch (error) {
                    console.error('❌ Error clearing assessment sessions:', error);
                    // If clearing fails, show an error message but still proceed
                    if (error?.response?.data?.message) {
                      console.warn('Error details:', error.response.data.message);
                    }
                  }

                  setShowStartOverConfirm(false);
                  await fetchUserAssignedAssessments();
                  setShowAssessmentSelectionModal(true);
                }}
              >
                <Icon name="refresh" size={18} />
                {language === 'fil' ? 'Simulan Muli' : 'Start Over'}
              </button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Custom Warning Modal */}
      {showCustomWarning && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Leave for now?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleWarningClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="am-intro">
                  <span className="am-intro-icon is-warning">
                    <Icon name="alert-triangle" size={28} />
                  </span>
                  <h3 className="am-intro-title">You're not done yet</h3>
                  <p className="am-intro-text">
                    Your answers so far are saved. Finish your career interests
                    test to see the programs that fit you.
                  </p>
                </div>
                <p className="am-note">
                  <Icon name="lightbulb" size={18} />
                  <span>Next time you open Anna, you can pick up where you left off.</span>
                </p>
              </div>
              <div className="modal-footer am-foot-split">
                <button
                  type="button"
                  className="am-btn"
                  onClick={handleWarningClose}
                >
                  Leave for now
                </button>
                <button
                  type="button"
                  className="am-btn is-primary"
                  onClick={handleWarningContinue}
                >
                  Keep going
                  <Icon name="arrow-right" size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomModal
        title={`${basis === "riasec" ? "RIASEC" : "Strand"} | Recommended Degree Programs`}
        target="modal-recommended-courses-info"
        size="modal-xl"
      >
        <div className="d-flex flex-column">
          <div className="am-courses-intro">
            <label className="am-search">
              <SearchIcon size={20} />
              <input
                type="search"
                placeholder={
                  language === "fil"
                    ? "Hanapin ang kurso..."
                    : "Search for a course..."
                }
                value={courseSearchTerm}
                onChange={(e) => setCourseSearchTerm(e.target.value)}
                aria-label={language === "fil" ? "Hanapin ang kurso" : "Search courses"}
              />
            </label>

            <p className="am-note">
              <Icon name="info" size={18} />
              <span>
                <b>{language === "fil" ? "Paano Gamitin" : "How to Use"}</b>{" "}
                {language === "fil"
                  ? "Pindutin ang anumang kurso at makakakuha kayo ng instant na explanation mula kay Anna. Makakita rin kayo ng 'View Details' button para sa kumpletong impormasyon. Makikita ninyo din kung anong ibang schools ang nag-offer ng program na iyon."
                  : "Click any course to get an instant explanation from Anna. You'll also see a 'View Details' button for complete program information. You'll also discover which other schools offer that program."}
              </span>
            </p>

            <div className="am-legend">
              <p className="am-note is-success">
                <CheckCircleIcon size={18} />
                <span>
                  <b>Good news!</b> Courses with green checkmarks are available right here at {schoolDisplayName}! These are programs you can enroll in directly at this school.
                </span>
              </p>
              <p className="am-note is-amber">
                <LandmarkIcon size={18} />
                <span>
                  <b>Explore options!</b> Courses with orange school icons are offered by other institutions. Click on them to see which schools offer these programs, including tuition fees, duration, and contact information.
                </span>
              </p>
            </div>
          </div>

          {basis === "riasec"
            ? riasecBasedRecommendedCourses.length > 0 && (
                <>
                  {/* Top 3 RIASEC Headers - Properly aligned */}
                  <Row className="mb-3 text-center d-none d-md-flex px-3">
                    {riasecCode.slice(0, 3).map(([category], index) => (
                      <Col key={index} md={4} className="mb-2">
                        <h4 className="am-col-title">
                          {category.toUpperCase()}
                        </h4>
                      </Col>
                    ))}
                  </Row>

                  {/* Full Course List per Category with Animation */}
                  <Row className="px-3">
                    {riasecCode.slice(0, 3).map(([category], index) => {
                      // Filter courses for the current category based on the search term
                      let filteredCourses = riasecCourses[category]?.filter(
                        (course) => {
                          const courseName =
                            typeof course === "string"
                              ? course
                              : course.name || course.stringValue || "";
                          return courseName
                            .toLowerCase()
                            .includes(courseSearchTerm.toLowerCase());
                        },
                      );
                      // Popularity sort with fallback
                      let sortKeyRiasec = "";
                      try {
                        const names = filteredCourses.map((c) =>
                          typeof c === "string"
                            ? c
                            : c.name || c.stringValue || "",
                        );
                        sortKeyRiasec = `modal:riasec:${category}:${names.join("|")}`;
                        const cached = popularOrderCache[sortKeyRiasec];
                        if (!cached && names.length > 0) {
                          api
                            .post("/api/sort-courses-by-popularity/", {
                              courses: names,
                              category: "riasec",
                            })
                            .then((resp) => {
                              const order = resp?.data?.sorted_courses;
                              const counts = resp?.data?.counts || {};
                              const total = resp?.data?.unique_users_total || 0;
                              setPopularOrderCache((prev) => ({
                                ...prev,
                                [sortKeyRiasec]: {
                                  order: order && order.length ? order : names,
                                  counts,
                                  total,
                                },
                              }));
                            })
                            .catch((error) => {
                              console.warn("Failed to sort courses by popularity (RIASEC):", error);
                              setPopularOrderCache((prev) => ({
                                ...prev,
                                [sortKeyRiasec]: {
                                  order: names,
                                  counts: {},
                                  total: 0,
                                },
                              }));
                            });
                        }
                        // Sort courses: 1st priority = offered courses, 2nd priority = popularity
                        const sortedCourses = filteredCourses.sort((a, b) => {
                          const aName = typeof a === "string" ? a : a.name || a.stringValue || "";
                          const bName = typeof b === "string" ? b : b.name || b.stringValue || "";
                          
                          const aIsOffered = offerings.some(
                            (o) => o.course_name.toLowerCase() === aName.toLowerCase() && o.is_offered !== false
                          );
                          const bIsOffered = offerings.some(
                            (o) => o.course_name.toLowerCase() === bName.toLowerCase() && o.is_offered !== false
                          );
                          
                          // First priority: offered courses come first
                          if (aIsOffered && !bIsOffered) return -1;
                          if (!aIsOffered && bIsOffered) return 1;
                          
                          // Second priority: popularity order
                          const order = popularOrderCache[sortKeyRiasec]?.order || names;
                          const aIndex = order.indexOf(aName);
                          const bIndex = order.indexOf(bName);
                          
                          if (aIndex === -1 && bIndex === -1) return 0;
                          if (aIndex === -1) return 1;
                          if (bIndex === -1) return -1;
                          
                          return aIndex - bIndex;
                        });
                        
                        // Apply three-tier priority sorting (current tenant > other schools > popular only)
                        filteredCourses = sortCoursesByPriority(sortedCourses, sortedCourses);
                      } catch {}
                      return (
                        <Col key={index} xs={12} md={4} className="mb-4">
                          <h4 className="am-col-title d-md-none">
                            {category.toUpperCase()}
                          </h4>
                          <ListGroup
                            as={motion.div}
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            transition={{ duration: 0.5 }}
                          >
                            {filteredCourses
                              ?.slice(0, visibleCourses)
                              .map((course, i) => (
                                <motion.div
                                  key={i}
                                  initial={{ opacity: 0, y: -10 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  transition={{
                                    duration: 0.3,
                                    delay: i * 0.05,
                                  }}
                                >
                                  <ListGroup.Item
                                    action
                                    className="course-list-item d-flex align-items-center"
                                    onClick={() =>
                                      handleRecommendedCourseClick(
                                        typeof course === "string"
                                          ? course
                                          : course.name,
                                      )
                                    }
                                  >
                                    {(() => {
                                      const name =
                                        typeof course === "string"
                                          ? course
                                          : course.name || "";
                                      // Check if this course is offered at the current school
                                      const isOffered = offerings.some(offering => 
                                        offering.course_name.toLowerCase() === name.toLowerCase() && offering.is_offered
                                      );
                                      // Only check other schools if NOT offered by current tenant
                                      const hasOtherSchools = !isOffered && coursesAtOtherSchools.has(name.toLowerCase());
                                      
                                      // Debug logging for icon display
                                      if (name.toLowerCase().includes('geology') || name.toLowerCase().includes('nutrition')) {
                                        console.log(`🔍 RIASEC Debug - Course: "${name}", lookup key: "${name.toLowerCase()}", isOffered: ${isOffered}, hasOtherSchools: ${hasOtherSchools}, coursesAtOtherSchools size: ${coursesAtOtherSchools.size}`);
                                        console.log(`🔍 RIASEC Debug - coursesAtOtherSchools contents:`, Array.from(coursesAtOtherSchools));
                                      }
                                      
                                      return (
                                        <div className="d-flex align-items-center me-3" style={{ minWidth: '3rem', flexShrink: 0 }}>
                                          <div style={{ width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {isOffered ? (
                                              <CheckCircleIcon title={`Available at ${schoolDisplayName}`} style={{ fontSize: '16px', color: '#2eb872' }} />
                                            ) : hasOtherSchools ? (
                                              <LandmarkIcon title="Available at other schools" style={{ fontSize: '16px', color: '#ff9800' }} />
                                            ) : null}
                                          </div>
                                          <StudentIcon className="text-muted ms-2" style={{ fontSize: '1.2rem', flexShrink: 0 }} />
                                        </div>
                                      );
                                    })()}
                                    {(() => {
                                      const name =
                                        typeof course === "string"
                                          ? course
                                          : course.name || "";
                                      const total =
                                        popularOrderCache[sortKeyRiasec]
                                          ?.total || 0;
                                      const counts =
                                        popularOrderCache[sortKeyRiasec]
                                          ?.counts || {};
                                      const pct =
                                        total > 0 && counts[name]
                                          ? Math.round(
                                              (counts[name] / total) * 100,
                                            )
                                          : null;
                                      
                                      return (
                                        <>
                                          <span className="course-name flex-grow-1 d-flex align-items-center">
                                            {name}
                                          </span>
                                          {pct ? (
                                            <span className="course-stat text-muted ms-3 text-nowrap">
                                              {pct}% also viewed
                                            </span>
                                          ) : null}
                                        </>
                                      );
                                    })()}
                                  </ListGroup.Item>
                                </motion.div>
                              ))}
                          </ListGroup>
                        </Col>
                      );
                    })}
                  </Row>

                  {/* "See More" / "See Less" Button */}
                  <div className="text-center mt-3 mb-3">
                    <Button
                      variant="link"
                      className="am-btn is-soft"
                      onClick={toggleCourseVisibility}
                      as={motion.button}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {visibleCourses >= MAX_VISIBLE_COURSES
                        ? language === "fil"
                          ? "Tingnan ang Mas Kaunti"
                          : "See Less"
                        : language === "fil"
                          ? "Tingnan ang Higit Pa"
                          : "See More"}
                    </Button>
                  </div>
                </>
              )
            : strandBasedRecommendedCourses.length > 0 && (
                <>
                  <Row className="mb-3 text-center">
                    <Col xs={12}>
                      <h4 className="am-col-title">
                        Strand-Based Recommendations
                      </h4>
                    </Col>
                  </Row>

                  <motion.div
                    className="px-3"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    transition={{ duration: 0.5 }}
                  >
                    {(() => {
                      // Popularity sort with fallback (strand list)
                      let list = strandBasedRecommendedCourses.filter(
                        (course) => {
                          const courseName =
                            typeof course === "object"
                              ? course.name || course.stringValue || ""
                              : course;
                          return courseName
                            .toLowerCase()
                            .includes(courseSearchTerm.toLowerCase());
                        },
                      );
                      let sortKeyStrand = "";
                      try {
                        const names = list.map((c) =>
                          typeof c === "string"
                            ? c
                            : c.name || c.stringValue || "",
                        );
                        const key = `modal:strand:${names.join("|")}`;
                        sortKeyStrand = key;
                        const cached = popularOrderCache[sortKeyStrand];
                        if (!cached && names.length > 0) {
                          api
                            .post("/api/sort-courses-by-popularity/", {
                              courses: names,
                              category: "strand",
                            })
                            .then((resp) => {
                              const order = resp?.data?.sorted_courses;
                              const counts = resp?.data?.counts || {};
                              const total = resp?.data?.unique_users_total || 0;
                              setPopularOrderCache((prev) => ({
                                ...prev,
                                [sortKeyStrand]: {
                                  order: order && order.length ? order : names,
                                  counts,
                                  total,
                                },
                              }));
                            })
                            .catch((error) => {
                              console.warn("Failed to sort courses by popularity (Strand):", error);
                              setPopularOrderCache((prev) => ({
                                ...prev,
                                [sortKeyStrand]: {
                                  order: names,
                                  counts: {},
                                  total: 0,
                                },
                              }));
                            });
                        }
                        // Popularity order (fallback to names)
                        const order = popularOrderCache[sortKeyStrand]?.order || names;
                        const popularityOrdered = order.map(
                          (n) =>
                            list.find(
                              (c) =>
                                (typeof c === "string"
                                  ? c
                                  : c.name || c.stringValue || "") === n,
                            ) || n,
                        );
                        // Apply three-tier priority sorting (current tenant > other schools > popular only)
                        list = sortCoursesByPriority(popularityOrdered, order, true);
                      } catch {}

                      return list.slice(0, visibleCourses).map((course, i) => (
                        <motion.div
                          key={i}
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3, delay: i * 0.05 }}
                        >
                          <div
                            className={`course-recommendation border-bottom py-2 d-flex align-items-center course-list-item ${knownCourses.includes(course) ? "active" : ""}`}
                            onClick={() => handleRecommendedCourseClick(course)}
                          >
                            {(() => {
                              const name =
                                typeof course === "string"
                                  ? course
                                  : course.name || "";
                              // Check if this course is offered at the current school
                              const isOffered = offerings.some(offering => 
                                offering.course_name.toLowerCase() === name.toLowerCase() && offering.is_offered
                              );
                              // Only check other schools if NOT offered by current tenant
                              const hasOtherSchools = !isOffered && coursesAtOtherSchools.has(name.toLowerCase());
                              
                              // Debug logging for icon display
                              if (name.toLowerCase().includes('geology') || name.toLowerCase().includes('nutrition')) {
                                console.log(`🔍 Strand Debug - Course: "${name}", lookup key: "${name.toLowerCase()}", isOffered: ${isOffered}, hasOtherSchools: ${hasOtherSchools}, coursesAtOtherSchools size: ${coursesAtOtherSchools.size}`);
                                console.log(`🔍 Strand Debug - coursesAtOtherSchools contents:`, Array.from(coursesAtOtherSchools));
                              }
                              
                              return (
                                <div className="d-flex align-items-center me-3" style={{ minWidth: '3rem', flexShrink: 0 }}>
                                  <div style={{ width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {isOffered ? (
                                      <CheckCircleIcon title={`Available at ${schoolDisplayName}`} style={{ fontSize: '16px', color: '#2eb872' }} />
                                    ) : hasOtherSchools ? (
                                      <LandmarkIcon title="Available at other schools" style={{ fontSize: '16px', color: '#ff9800' }} />
                                    ) : null}
                                  </div>
                                  <StudentIcon className="text-muted ms-2" style={{ fontSize: '1.2rem', flexShrink: 0 }} />
                                </div>
                              );
                            })()}
                            {(() => {
                              const name =
                                typeof course === "string"
                                  ? course
                                  : course.name || "";
                              const total =
                                popularOrderCache[sortKeyStrand]?.total || 0;
                              const counts =
                                popularOrderCache[sortKeyStrand]?.counts || {};
                              const pct =
                                total > 0 && counts[name]
                                  ? Math.round((counts[name] / total) * 100)
                                  : null;
                              
                              return (
                                <>
                                  <span className="course-name flex-grow-1 d-flex align-items-center">
                                    {name}
                                  </span>
                                  {pct ? (
                                    <span className="course-stat text-muted ms-3 text-nowrap">
                                      {pct}% also viewed
                                    </span>
                                  ) : null}
                                </>
                              );
                            })()}
                          </div>
                        </motion.div>
                      ));
                    })()}
                  </motion.div>

                  {/* "See More" / "See Less" Button */}
                  <div className="text-center mt-3 mb-3">
                    <Button
                      variant="link"
                      className="am-btn is-soft"
                      onClick={toggleCourseVisibility}
                      as={motion.button}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {visibleCourses >= MAX_VISIBLE_COURSES
                        ? language === "fil"
                          ? "Tingnan ang Mas Kaunti"
                          : "See Less"
                        : language === "fil"
                          ? "Tingnan ang Higit Pa"
                          : "See More"}
                    </Button>
                  </div>
                </>
              )}
        </div>
      </CustomModal>

      {/* Feedback Modal */}
      {showFeedbackModal && (
        <FeedbackModal
          show={showFeedbackModal}
          onClose={() => setShowFeedbackModal(false)}
          isLoggedIn={isLoggedIn}
          target="feedback-modal"
          category={currentAssessmentView === 'main' ? 'chatbot' : currentAssessmentView} // Dynamic category based on current view
        />
      )}

      {/* Test shell: the rating window when the student leaves, and "Leave for now?" mid-test */}
      <SessionRatingModal
        show={Boolean(ratingRequest)}
        tests={ratingRequest?.tests || []}
        language={language}
        onDone={() => {
          const after = ratingRequest?.after;
          setRatingRequest(null);
          if (after) after();
        }}
      />
      <LeaveTestDialog
        show={Boolean(leavePrompt)}
        question={leavePrompt?.question}
        testTitle={leavePrompt ? TEST_TITLES[leavePrompt.key] : ''}
        language={language}
        onStay={() => setLeavePrompt(null)}
        onLeave={() => {
          setLeavePrompt(null);
          setShowbot(false);
          testActiveRef.current = { active: false, question: 0, key: null };
          setCurrentAssessmentView('main');
          setShowProgressIndicator(false);
        }}
      />

      {/* Course Details Modal */}
      {showCourseDetailsModal && selectedCourseDetails && (
        <Modal
          show={showCourseDetailsModal}
          onHide={() => {
            setShowCourseDetailsModal(false);
            setModalThemeColor('#0d6efd');
          }}
          size="lg"
          fullscreen="sm-down"
          centered
          className="course-details-modal"
          backdropClassName="course-details-backdrop"
          style={{ zIndex: 2000 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <GraduationCapIcon size={22} />
              Course Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CourseDetailsCards
              selectedCourse={selectedCourseDetails}
              schoolDisplayName={schoolDisplayName}
              otherSchools={otherSchools}
              otherSchoolsLoading={otherSchoolsLoading}
              activeSchoolTab={activeSchoolTab}
              setActiveSchoolTab={setActiveSchoolTab}
              onThemeColorChange={handleThemeColorChange}
              isOfferedByCurrentTenant={selectedCourseDetails?.is_offered !== false && offerings.some(
                (o) => o.course_name.toLowerCase() === selectedCourseDetails?.course_name?.toLowerCase() && o.is_offered !== false
              )}
            />
            
            <p className="am-note">
              <Icon name="info" size={18} />
              <span>Don't worry — you can view this again on your Results page after your conversation.</span>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="am-btn"
              onClick={() => setShowCourseDetailsModal(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="am-btn is-primary"
              onClick={() => {
                setShowCourseDetailsModal(false);
                if (inputRef.current) {
                  inputRef.current.focus();
                }
              }}
            >
              <Icon name="chat" size={18} />
              Continue Chat with Anna
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Chatbot;
